import React from 'react';

import styled, { IThemeColorsUnion } from '../lib/styled_components';

// https://www.smooth-code.com/open-source/svgr/playground/

export const TodoList1Icon = (props) => (
  <svg viewBox="0 0 46.5 48" width="1em" height="1em" {...props}>
    <defs>
      <style>
        {
          '.cls-1,.cls-2{fill:none;stroke-width:2px}.cls-1{stroke-miterlimit:10}.cls-2{stroke-linejoin:round}'
        }
      </style>
    </defs>
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M37 33v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4M31 6h4a2 2 0 0 1 2 2v9"
    />
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M33 37v6H5V10h2M31 10h2v11M26 5h-3a4 4 0 0 0-8 0h-3a3 3 0 0 0-3 3v3h20V8a3 3 0 0 0-3-3zM19 4v2"
    />
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M44.33 17.75a3.27 3.27 0 0 1 1.15 2.6L30.05 35.78A8.67 8.67 0 0 1 24 38a8.69 8.69 0 0 1 2.23-6l15.43-15.47a3.27 3.27 0 0 1 2.6 1.15zM39.52 18.6l3.82 3.82M26 32l4 4"
    />
    <path
      className="cls-2 svg-icon-color-stroke"
      d="M19 16h9M16 15l-4 5-2-3M19 25h9M19 20h7M19 29h6M16 24l-4 5-2-3M16 33l-4 5-2-3"
    />
  </svg>
);

export const DownloadIcon = (props) => {
  return (
    <svg viewBox="0 0 48 47" width="1.4em" height="1.4em" {...props}>
      <defs>
        <style>
          {'.prefix__cls-1{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:2px}'}
        </style>
      </defs>
      <title>{'download'}</title>
      <g id="prefix__Layer_2" data-name="Layer 2">
        <g id="prefix__icons">
          <path
            className="prefix__cls-1"
            d="M1 28l15 7 8-5v-1L9 22l-8 5v1zM47 28l-15 7-8-5v-1l15-7 8 5v1zM15 19.2L9 22l-8-4v-1l15-7 1 .62M33 19.2l6 2.8 8-4v-1l-15-7-1 .63M24 30v16"
          />
          <path className="prefix__cls-1" d="M39 32v7l-15 7-15-7v-7M28 1v13h5l-9 10-9-10h5V1h8z" />
        </g>
      </g>
    </svg>
  );
};

export const WaveIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1440 320"
      width="80em"
      height="11em"
      {...props}
    >
      <path
        fill="#3662a7"
        fillOpacity="0.4"
        d="M0,320L26.7,293.3C53.3,267,107,213,160,176C213.3,139,267,117,320,117.3C373.3,117,427,139,480,154.7C533.3,171,587,181,640,165.3C693.3,149,747,107,800,106.7C853.3,107,907,149,960,160C1013.3,171,1067,149,1120,160C1173.3,171,1227,213,1280,224C1333.3,235,1387,213,1413,202.7L1440,192L1440,0L1413.3,0C1386.7,0,1333,0,1280,0C1226.7,0,1173,0,1120,0C1066.7,0,1013,0,960,0C906.7,0,853,0,800,0C746.7,0,693,0,640,0C586.7,0,533,0,480,0C426.7,0,373,0,320,0C266.7,0,213,0,160,0C106.7,0,53,0,27,0L0,0Z"
      />
    </svg>
  );
};

export const ArrowIcon = (props) => {
  return (
    <svg viewBox="0 0 367 308" width="1.5rem" height="1.5rem" {...props}>
      <path
        d="M246.94 56H113c-2.44 0-3-.63-3-3q.18-23.36 0-46.73c0-2.11.4-2.84 2.71-2.83q110.34.09 220.68 0c2.81 0 4 1.26 4 4.14q0 110.08.05 220.17c0 2.15-.47 2.82-2.74 2.81q-23.49-.17-47 0c-2.35 0-2.86-.7-2.86-2.93q.09-65.73.05-131.46V93c-1 1-1.76 1.62-2.43 2.3l-208 208c-1.75 1.75-2.58 1.83-4.36 0q-16.29-16.57-32.86-32.87c-1.71-1.69-1.73-2.52 0-4.24q104-103.83 207.88-207.75a15.59 15.59 0 012.46-1.66z"
        fill="#7ed4b3"
      />
    </svg>
  );
};

export const CoinsIcon = (props) => (
  <svg viewBox="0 0 39 47" width="1em" height="1em" {...props}>
    <defs>
      <style>
        {'.cls-1{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}'}
      </style>
    </defs>
    <path className="cls-1 svg-icon-color-stroke" d="M38 7c0 3.31-4.48 6-10 6s-10-2.69-10-6" />
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M38 12c0 3.31-4.48 6-10 6s-10-2.69-10-6M38 17c0 3.31-4.48 6-10 6a15.87 15.87 0 0 1-4-.5M38 22c0 3.31-4.48 6-10 6a15.87 15.87 0 0 1-4-.5M38 27c0 3.31-4.48 6-10 6a15.87 15.87 0 0 1-4-.5M11 19c-5.52 0-10 2.69-10 6v15c0 3.31 4.48 6 10 6s10-2.69 10-6V25c0-3.31-4.48-6-10-6z"
    />
    <path className="cls-1 svg-icon-color-stroke" d="M21 25c0 3.31-4.48 6-10 6S1 28.31 1 25" />
    <path className="cls-1 svg-icon-color-stroke" d="M21 30c0 3.31-4.48 6-10 6S1 33.31 1 30" />
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M21 35c0 3.31-4.48 6-10 6S1 38.31 1 35M24 37.5a15.93 15.93 0 0 0 4 .5c5.52 0 10-2.69 10-6V7c0-3.31-4.48-6-10-6S18 3.69 18 7v10"
    />
  </svg>
);

export const WalletIcon = (props) => (
  <svg viewBox="0 0 46 43" width="1em" height="1em" {...props}>
    <defs>
      <style>
        {'.cls-1{fill:none;stroke-width:2px;stroke-linecap:round;stroke-linejoin:round}'}
      </style>
    </defs>
    <path className="cls-1 svg-icon-color-stroke" d="M13 9H4a3 3 0 0 0-3 3M38 15V9h-9" />
    <path className="cls-1 svg-icon-color-stroke" d="M35 15L21 1 7 15" />
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M28 15l-4.87-4.9a2.64 2.64 0 0 1-4.24 0L14 15"
    />
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M43 34v8H4a3 3 0 0 1-3-3V12a3 3 0 0 0 3 3h39v7"
    />
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M31 24a4.83 4.83 0 0 0-5 5 4.83 4.83 0 0 0 5 5h11a3 3 0 0 0 3-3v-8a1 1 0 0 0-1-1h-1a2.17 2.17 0 0 1-2 2H31"
    />
    <path
      className="svg-icon-color-stroke"
      strokeMiterlimit={10}
      fill="none"
      stroke="#505050"
      strokeWidth={2}
      d="M30 29h2"
    />
  </svg>
);

export const BuildingIcon = (props) => (
  <svg viewBox="0 0 48 41.07" width="1em" height="1em" {...props}>
    <defs>
      <style>{'.cls-1{fill:none;stroke-miterlimit:10;stroke-width:2px}'}</style>
    </defs>
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M24 1.07l-23 9v1l1 2h44l1-2v-1l-23-9zM32 34.07v-13a3 3 0 0 1 3-3 3 3 0 0 1 3 3v13M21 34.07v-13a3 3 0 0 1 3-3 3 3 0 0 1 3 3v13M10 34.07v-13a3 3 0 0 1 3-3 3 3 0 0 1 3 3v13M3 15.07v2l2 1v18M43 36.07v-18l2-1v-2M2 36.07h44M2 40.07h44"
    />
  </svg>
);

export const SpinningCircleIcon = (props) => (
  <svg viewBox="0 0 44.34 44.87" width="1em" height="1em" {...props}>
    <defs>
      <style>
        {
          '.cls-1,.cls-2{fill:none;stroke-linecap:round;stroke-width:2px}.cls-1{stroke-linejoin:round}.cls-2{stroke-miterlimit:10}'
        }
      </style>
    </defs>
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M39.16 33.3a2.77 2.77 0 0 1-.59 2.34 3 3 0 0 1-2.61.57M37 27.64a25.1 25.1 0 0 1 1.25 2.48"
    />
    <path
      className="cls-2 svg-icon-color-stroke"
      d="M41.28 17.26l-4.96.58-.59-4.96M11.88 1l1.65 3.64L9.9 6.33"
    />
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M15.72 38l1.59-1.16M10.7 41.28l2-1.21M36.32 17.84C42 10.45 44.69 4.25 42.68 2.26c-2.9-2.86-14.47 4-25.77 15.34S-1.23 40.36 1.66 43.23c1.17 1.15 3.63.55 5.65-.26"
    />
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M9.52 13.84A12.9 12.9 0 0 0 7.38 21a13.07 13.07 0 0 0 1.34 5.75M26.15 9.35a13 13 0 0 0-14.41 1.93M29.83 29.92A12.82 12.82 0 0 0 33.38 21 13.07 13.07 0 0 0 29 11.28M10.43 29.36A13 13 0 0 0 27.3 32"
    />
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M12.44 17.85C7.23 11.29 4.67 5.5 6.56 3.61c1.14-1.14 3.69-.66 7 1M32.94 35.27c-4-1.77-9.51-5.76-14.85-11.12-.49-.49-1-1-1.43-1.47"
    />
  </svg>
);

export const OppositeArrowsIcon = (props) => (
  <svg viewBox="0 0 45 47.41" width="1em" height="1em" {...props}>
    <defs>
      <style>{'.cls-1{fill:none;stroke-miterlimit:10;stroke-width:2px}'}</style>
    </defs>
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M14 15.71l-8 8-5-5v19h18l-5-5 17-17-5-5h18v19l-5-5-7 7M19 10.71l-3 3M24 5.71l-3 3M29 .71l-3 3M20 43.71l-3 3M25 38.71l-3 3M30 33.71l-3 3M6 15.71l10-10M29 43.71l10-10"
    />
  </svg>
);

export const BanknoteWithArrowsIcon = (props) => (
  <svg viewBox="0 0 47.77 42.41" width="1em" height="1em" {...props}>
    <defs>
      <style>{'.cls-1{fill:none;stroke-miterlimit:10;stroke-width:2px}'}</style>
    </defs>
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M10 36.41h28v3l8-5-8-6v3H11a3 3 0 0 0-3-3v-8a2.8 2.8 0 0 0 3-3h24a2.8 2.8 0 0 0 3 3v4M4 17.41v15"
    />
    <path className="cls-1 svg-icon-color-stroke" d="M42 27.41v-14H5M14 24.41h2M31 24.41h2" />
    <circle className="cls-1 svg-icon-color-stroke" cx={23} cy={24.4} r={4} />
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M8 36.41H5M3 36.41H0M34 41.41H22M20 41.41h-3M15 41.41h-3M17 6.41h12v-4l6 6-2 2M15 6.41h-3M10 6.41H7M3 13.41H0"
    />
  </svg>
);

export const Cog1Icon = (props) => (
  <svg viewBox="0 0 47.77 47.66" width="1em" height="1em" {...props}>
    <defs>
      <style>{'.cls-1{fill:none;stroke-miterlimit:10;stroke-width:2px}'}</style>
    </defs>
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M38.48 14.58l-1.81-4.35-1.23-.57-2.14.71-1.11-.37a15.16 15.16 0 0 0-2.66-2.65l-.35-1.11.72-2.14-.57-1.24L25 1.07l-1.28.48-1 2-1 .54a15.84 15.84 0 0 0-3.77 0l-1-.53-1-2-1.28-.48-4.44 1.8-.57 1.24.71 2.14-.37 1.1A15.21 15.21 0 0 0 7.37 10l-1.11.34-2.14-.68-1.24.57-1.81 4.35.48 1.28 2 1 .54 1a15.76 15.76 0 0 0 0 3.76c-.2.38-.34.65-.53 1l-2 1c-.18.5-.29.79-.48 1.28l1.81 4.36 1.24.57 2.14-.72 1.1.35A15.63 15.63 0 0 0 10 32.19l.34 1.1-.71 2.14.57 1.24 4.35 1.81 1.31-.48 1-2 1-.54a15.76 15.76 0 0 0 3.76 0l1 .54 1 2 1.28.48 4.36-1.81.57-1.23-.72-2.14.35-1.11a15.57 15.57 0 0 0 2.66-2.66l1.1-.35 2.15.72 1.23-.57L38.48 25 38 23.69l-2-1-.54-1a15.85 15.85 0 0 0 0-3.77l.54-1 2-1c.19-.55.3-.85.48-1.34zM46.8 30.59l-1-.62-.55-1.55-1.2-.57-2.24.79c-.23.47-.35.74-.57 1.2l.54 1.55c-.13.4-.21.68-.34 1.08a10.29 10.29 0 0 0-1.25 1.12l-1.11.24-1.48-.71-1.25.45-1 2.15.46 1.28 1.48.71c.19.38.32.64.52 1a9.31 9.31 0 0 0-.09 1.67l-.62 1-1.55.54-.55 1.14.8 2.25 1.2.57 1.54-.55 1.09.35a8.26 8.26 0 0 0 1.12 1.24"
    />
    <ellipse className="cls-1 svg-icon-color-stroke" cx={19.77} cy={19.67} rx={11} ry={10.98} />
    <path className="cls-1 svg-icon-color-stroke" d="M47.77 44.65a4 4 0 0 1 0-8" />
  </svg>
);

export const CurrencyIcon = (props) => (
  <svg viewBox="0 0 47.77 42.41" width="1em" height="1em" {...props}>
    <defs>
      <style>{'.cls-1{fill:none;stroke-miterlimit:10;stroke-width:2px}'}</style>
    </defs>
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M10 36.41h28v3l8-5-8-6v3H11a3 3 0 0 0-3-3v-8a2.8 2.8 0 0 0 3-3h24a2.8 2.8 0 0 0 3 3v4M4 17.41v15"
    />
    <path className="cls-1 svg-icon-color-stroke" d="M42 27.41v-14H5M14 24.41h2M31 24.41h2" />
    <circle className="cls-1 svg-icon-color-stroke" cx={23} cy={24.4} r={4} />
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M8 36.41H5M3 36.41H0M34 41.41H22M20 41.41h-3M15 41.41h-3M17 6.41h12v-4l6 6-2 2M15 6.41h-3M10 6.41H7M3 13.41H0"
    />
  </svg>
);

export const CSVIcon = (props) => (
  <svg viewBox="0 0 40.71 46" width="1em" height="1em" {...props}>
    <defs>
      <style>{'.cls-1{fill:none;stroke-linejoin:round;stroke-width:2px}'}</style>
    </defs>
    <path className="cls-1 svg-icon-color-stroke" d="M29 36v9H1V1h28v7" />
    <circle className="cls-1 svg-icon-color-stroke" cx={25} cy={22} r={12} />
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M32 31l8 8M5 8h12M5 12h8M5 16h5M5 20h5M5 24h5M19 18h11M19 22h11M19 26h7M6 37v4M10 33v8M14 36v5M18 39v2M22 37v4"
    />
  </svg>
);

export const ZoomedBinaryCodeIcon = (props) => (
  <svg viewBox="0 0 48 30" width="1em" height="1em" {...props}>
    <defs>
      <style>{'.cls-1{fill:none;stroke-miterlimit:10;stroke-width:2px}'}</style>
    </defs>
    <rect
      className="cls-1 svg-icon-color-stroke"
      x={1}
      y={1}
      width={4}
      height={6}
      rx={1}
      transform="rotate(180 3 4)"
    />
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M33 7V2a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v2M19 4V2a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v5"
    />
    <rect className="cls-1 svg-icon-color-stroke" x={38} y={12} width={4} height={6} rx={1} />
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M38 25v-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1M10 0v8M24 0v4M47 11v8M47 22v8"
    />
    <rect
      className="cls-1 svg-icon-color-stroke"
      x={43}
      y={1}
      width={4}
      height={6}
      rx={1}
      transform="rotate(180 45 4)"
    />
    <path className="cls-1 svg-icon-color-stroke" d="M38 0v8" />
    <rect
      className="cls-1 svg-icon-color-stroke"
      x={6}
      y={12}
      width={4}
      height={6}
      rx={1}
      transform="rotate(180 8 15)"
    />
    <path className="cls-1 svg-icon-color-stroke" d="M1 11v8" />
    <rect className="cls-1 svg-icon-color-stroke" x={1} y={23} width={4} height={6} rx={1} />
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M33 27v1a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2M24 26v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2M10 22v8M15 23v7"
    />
    <circle className="cls-1 svg-icon-color-stroke" cx={24} cy={15} r={9} />
    <rect className="cls-1 svg-icon-color-stroke" x={24} y={12} width={4} height={6} rx={1} />
    <path className="cls-1 svg-icon-color-stroke" d="M20 11v8M30 21l8 8" />
  </svg>
);

export const TodoList2Icon = (props) => (
  <svg viewBox="0 0 44.5 45" width="1em" height="1em" {...props}>
    <defs>
      <style>
        {
          '.cls-1,.cls-2{fill:none;stroke-width:2px}.cls-1{stroke-miterlimit:10}.cls-2{stroke-linejoin:round}'
        }
      </style>
    </defs>
    <g id="icons">
      <path className="cls-1 svg-icon-color-stroke" d="M33 33v11H1V1h32v16" />
      <path
        className="cls-1 svg-icon-color-stroke"
        d="M42.33 15.75a3.27 3.27 0 0 1 1.15 2.6L28.05 33.78A8.67 8.67 0 0 1 22 36a8.69 8.69 0 0 1 2.23-6l15.43-15.47a3.27 3.27 0 0 1 2.6 1.15zM37.52 16.6l3.82 3.82M24 30l4 4"
      />
      <path
        className="cls-2 svg-icon-color-stroke"
        d="M17 12h9M14 11l-4 5-2-3M17 21h9M17 16h7M17 25h6M14 20l-4 5-2-3M14 29l-4 5-2-3"
      />
    </g>
  </svg>
);

export const AccountIcon = (props) => (
  <svg viewBox="0 0 46 41" width="1em" height="1em" {...props}>
    <defs>
      <style>{'.cls-1{fill:none;stroke-linejoin:round;stroke-width:2px}'}</style>
    </defs>
    <path className="cls-1 svg-icon-color-stroke" d="M31 7h14v33H1V7h16" />
    <path className="cls-1 svg-icon-color-stroke" d="M6 16h16v19H6z" />
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M14 35h8v-3.42A15.93 15.93 0 0 0 14 29a15.93 15.93 0 0 0-8 2.55V35zM14 19a3 3 0 0 0-3 3v1a3 3 0 0 0 3 3 3 3 0 0 0 3-3v-1a3 3 0 0 0-3-3zM27 20h13M27 24h13M27 28h7M16 11h16M14 11h-2M34 11h2M20 1h8v10h-8z"
    />
  </svg>
);

export const FortressIcon = (props) => (
  <svg viewBox="0 0 34 48" width="1em" height="1em" {...props}>
    <defs>
      <style>{'.cls-1{fill:none;stroke-linejoin:round;stroke-width:2px}'}</style>
    </defs>
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M28 47v-5a3.08 3.08 0 0 0-3.1-3H24v-2c0-1.66-.44-2-2.1-2H21v-6l5-4V14h-5v4h-4v-4h-5v4H8v-4H3v11l5 4v6h-.9c-1.66 0-2.1.34-2.1 2v2h-.9A3.08 3.08 0 0 0 1 42v5zM5 39h10M20 39h4M3 24h12M20 24h6M23 8h-8V2h10v3"
    />
    <path className="cls-1 svg-icon-color-stroke" d="M23 5h10v5H23zM15 12V0" />
  </svg>
);

export const Cog2Icon = (props) => (
  <svg viewBox="0 0 24.19 24.19" width="1em" height="1em" {...props}>
    <defs>
      <style>{'.Cog2Icon{fill:none;stroke-linejoin:round;stroke-width:1px}'}</style>
    </defs>
    <path
      className="Cog2Icon svg-icon-color-stroke"
      d="M23.19 9.57L21.73 6l-2.16.72a9 9 0 0 0-2.13-2.13l.72-2.15L14.62 1l-1 2a9.21 9.21 0 0 0-3 0l-1-2L6 2.47l.72 2.15a9.16 9.16 0 0 0-2.1 2.13L2.47 6 1 9.57l2 1a9.21 9.21 0 0 0 0 3l-2 1 1.47 3.54 2.15-.72a9.16 9.16 0 0 0 2.13 2.13L6 21.73l3.54 1.46 1-2a9 9 0 0 0 3 0l1 2 3.54-1.46-.72-2.16a9 9 0 0 0 2.13-2.13l2.16.72 1.46-3.54-2-1a9 9 0 0 0 0-3z"
    />
    <circle className="Cog2Icon svg-icon-color-stroke" cx={12.24} cy={12.24} r={3.65} />
  </svg>
);

export const EmailInHandIcon = (props) => (
  <svg viewBox="0 0 48 43" width="1em" height="1em" {...props}>
    <defs>
      <style>{'.cls-1{fill:none;stroke-miterlimit:10;stroke-width:2px}'}</style>
    </defs>
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M17 38v-2s3-2.25 3-5v-4M9 15l-5 4c-1.41 1.3-2 2-2 4v15M1 43v-5h18v5M6 26l8-8c1.84-1.84 4.71 2.75 2.51 5.49L14 26v3a3.72 3.72 0 0 1-4 4"
    />
    <path className="cls-1 svg-icon-color-stroke" d="M9 22V1h38v26H14" />
    <path className="cls-1 svg-icon-color-stroke" d="M9 1l6 8h26l6-8M25 5h6" />
  </svg>
);

export const LogoutIcon = (props) => (
  <svg height="1em" viewBox="0 0 1093 1024" width="1em" {...props}>
    <path
      className="svg-icon-color-stroke svg-icon-color-fill"
      d="M1082.972 434.823c10.994-10.902 10.994-28.63 0-39.536l-169.219-167.77a28.43 28.43 0 0 0-19.967-8.166c-7.219 0-14.439 2.683-19.968 8.166-10.996 10.9-10.996 28.628 0 39.536l121.047 120.01H639.91c-15.566 0-28.202 12.528-28.202 27.963 0 15.434 12.636 27.962 28.202 27.962h354.956L873.818 563.004c-10.996 10.902-10.996 28.63 0 39.536 11 10.907 28.88 10.907 39.881 0l169.213-167.77.06.053zM87.377 0C39.2 0 0 38.253 0 85.259v682.048c0 42.4 31.278 88.669 71.182 105.374l300.713 125.727c10.366 4.32 20.91 6.477 30.989 6.477 12.411 0 24.177-3.295 34.31-9.773 18.35-11.767 28.84-32.685 28.84-57.294v-85.257h145.634c48.178 0 87.383-38.253 87.383-85.254V596.791c0-15.686-13.05-28.414-29.128-28.414s-29.128 12.728-29.128 28.414v170.516c0 15.687-13.049 28.42-29.127 28.42H466.033V255.77c0-42.345-31.283-88.609-71.188-105.32L171.034 56.839h440.634c16.078 0 29.127 12.733 29.127 28.42V255.77c0 15.686 13.05 28.419 29.128 28.419 16.077 0 29.128-12.733 29.128-28.419V85.259C699.05 38.253 659.846 0 611.668 0H87.378zM58.25 767.307V85.26c0-4.495 1.05-8.755 2.973-12.505l310.672 129.928c18.756 7.843 35.883 33.135 35.883 53.088v682.048c0 5.914-1.572 9.21-2.622 9.833-1.05.623-4.717.797-10.31-1.533L94.138 820.39c-18.761-7.843-35.889-33.136-35.889-53.083z"
    />
  </svg>
);

export const NotifyIcon = (props) => (
  <svg viewBox="0 0 43 41" width="1em" height="1em" {...props}>
    <defs>
      <style>{'.cls-1{fill:none;stroke-miterlimit:10;stroke-width:2px}'}</style>
    </defs>
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M21 4v4M25 38c0 1.1-1.79 2-4 2s-4-.9-4-2M6 12a6 6 0 0 1 6-6M1 12A11 11 0 0 1 12 1M37 12a6 6 0 0 0-6-6M42 12A11 11 0 0 0 31 1M31 28V18a10 10 0 0 0-20 0v10l-4 6v2h28v-2z"
    />
  </svg>
);

export const Cog3Icon = (props) => (
  <svg viewBox="0 0 45 45" width="1em" height="1em" {...props}>
    <defs>
      <style>{'.cls-1{fill:none;stroke-linejoin:round;stroke-width:2px}'}</style>
    </defs>
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M25 7V2h-8v4.52a16.23 16.23 0 0 0-4.12 1.71L9.69 5 4 10.69l3.2 3.19A16.08 16.08 0 0 0 5.52 18H1v8h4.52a16.08 16.08 0 0 0 1.71 4.12L4 33.31 9.69 39l3.19-3.2A16.23 16.23 0 0 0 17 37.48V42h8v-5M27 11h1l5-5"
    />
    <path className="cls-1 svg-icon-color-stroke" d="M33 39l-6-6h-6a11 11 0 0 1 0-22" />
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M22 27h-1a5 5 0 0 1 0-10h8l4-4h5M38 32h-4l-5-5h-1"
    />
    <circle className="cls-1 svg-icon-color-stroke" cx={35} cy={4} r={3} />
    <circle className="cls-1 svg-icon-color-stroke" cx={41} cy={13} r={3} />
    <circle className="cls-1 svg-icon-color-stroke" cx={41} cy={22} r={3} />
    <circle className="cls-1 svg-icon-color-stroke" cx={41} cy={32} r={3} />
    <circle className="cls-1 svg-icon-color-stroke" cx={35} cy={41} r={3} />
    <path className="cls-1 svg-icon-color-stroke" d="M28 22h9M20 22h2M24 22h2M24 27h2M23 11h2" />
  </svg>
);

export const Cog4Icon = (props) => (
  <svg viewBox="0 0 47.78 43.61" width="1em" height="1em" {...props}>
    <defs>
      <style>{'.cls-1{fill:none;stroke-linejoin:round;stroke-width:2px}'}</style>
    </defs>
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M17.72 12.23l1.92-4.64 2.82.94a12.11 12.11 0 0 1 2.79-2.79l-.94-2.82L29 1l1.33 2.66a11.9 11.9 0 0 1 3.95 0L35.56 1l4.63 1.92-.94 2.82A11.92 11.92 0 0 1 42 8.53l2.82-.94 1.92 4.64-2.66 1.33a11.58 11.58 0 0 1 0 3.94l2.66 1.33-1.92 4.64-2.82-.94a12.11 12.11 0 0 1-2.79 2.79l.94 2.82-4.63 1.92-1.3-2.66a12.11 12.11 0 0 1-3.94 0L29 30.06l-4.64-1.92.94-2.82a12.11 12.11 0 0 1-2.79-2.79l-2.82.94-1.92-4.64 2.66-1.33a12.11 12.11 0 0 1 0-3.94z"
    />
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M27.81 17.37a4.81 4.81 0 1 0 2.6-6.29 4.8 4.8 0 0 0-2.6 6.29zM14 14.39a3.32 3.32 0 1 0-4.72 4.15M1.57 30.41l1.31-3.17 2.45 1a7.54 7.54 0 0 1 1.76-1.76L6.08 24l3.17-1.31 1 2.45a7.43 7.43 0 0 1 2.49 0l1-2.45 3.2 1.31-1 2.45a7.54 7.54 0 0 1 1.76 1.76l2.46-1 1.31 3.17-2.45 1a7.7 7.7 0 0 1 0 2.49l2.45 1-1.33 3.23-2.45-1a7.78 7.78 0 0 1-1.77 1.76l1 2.45-3.17 1.32-1-2.45a7.7 7.7 0 0 1-2.49 0l-1 2.45-3.18-1.33 1-2.46a7.54 7.54 0 0 1-1.76-1.76l-2.45 1-1.3-3.15 2.45-1a7.43 7.43 0 0 1 0-2.49z"
    />
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M5.09 20.28l-2.35 1.15-1.47-3 2.34-1.14a7.37 7.37 0 0 1-.14-2.44L1 14l1.1-3.19 2.47.86a7.3 7.3 0 0 1 1.62-1.88L5.05 7.44 8.09 6l1.14 2.31a7.38 7.38 0 0 1 2.44-.15l.85-2.46 3.19 1.1-.85 2.46M8.43 31.39a3.33 3.33 0 1 0 4.35-1.8 3.34 3.34 0 0 0-4.35 1.8z"
    />
  </svg>
);

export const BoxIcon = (props) => (
  <svg viewBox="0 0 84.54 97" width="1em" height="1em" {...props}>
    <path
      className="svg-icon-color-stroke svg-icon-color-fill"
      d="M84.54 25.25v-.2a.5.5 0 0 1 0-.12v-.26-.25a.75.75 0 0 0-.07-.12.17.17 0 0 0 0-.05v-.05a.41.41 0 0 1-.07-.11l-.32-.09-.09-.1-.08-.08-.11-.09a.39.39 0 0 0-.1-.08l-.1-.07h-.06L43.27.27h-.06L43.1.18 43 .13h-.24L42.6 0H41.44l-.11.06h-.06L1 23.52a1.72 1.72 0 0 0-.37.28l-.09.1a1.46 1.46 0 0 0-.21.28.41.41 0 0 0-.07.11 1.72 1.72 0 0 0-.18.42 1.84 1.84 0 0 0-.08.49.43.43 0 0 0 0 .05V71.94a.68.68 0 0 1 0 .14v.5l.06.11v.06l.07.12.13.15.09.11.15.12.16.12h.06l40.55 23.36a1.74 1.74 0 0 0 .49.2 1.79 1.79 0 0 0 .51.07 2.32 2.32 0 0 0 .38 0h.13a1.34 1.34 0 0 0 .18-.07 2.68 2.68 0 0 0 .3-.12l40.28-23.33h.06l.16-.12.15-.12.09-.11.13-.15.07-.12v-.06l.06-.11v-.5a.68.68 0 0 1 0-.14v-.13-.06zm-19.87 8l-20.4-11.76v-16l34.26 19.76zm-24.4-11.76L19.92 33.24 6 25.25 40.27 5.46zM19.86 63.77l14.52 8.38a2 2 0 1 0 2-3.47L21.86 60.3V45.06a2 2 0 0 0-4 0V60.3L4 68.29V28.71l14.52 8.34a2 2 0 0 0 .74.43l21 12.08v23.92a1.82 1.82 0 0 0 .06.46 1.63 1.63 0 0 0-.06.45v17.15L6 71.75zM42.27 46.1L23.93 35.55l18.17-10.5h.34l18.22 10.47zm1.94 27.84a1.82 1.82 0 0 0 .06-.46V49.56l21.39-12.3 14.88-8.56v39.59l-13.87-8V45.06a2 2 0 0 0-4 0V60.3l-14.51 8.38a2 2 0 1 0 2 3.47l14.52-8.38 13.86 8-34.27 19.77V74.39a1.63 1.63 0 0 0-.06-.45z"
    />
  </svg>
);

export const MonitorIcon = (props) => (
  <svg viewBox="0 0 118.66 97" width="1em" height="1em" {...props}>
    <path
      className="svg-icon-color-stroke svg-icon-color-fill"
      d="M78.65 18.28H58.48a2 2 0 1 1 0-4h20.17a2 2 0 0 1 0 4zm-15.6 34.17A2 2 0 0 1 61.63 49l22.93-22.89a2.001 2.001 0 0 1 2.83 2.83L64.46 51.87a2 2 0 0 1-1.41.58zm-26.19 2.83a2 2 0 0 1-1.42-3.42l13.05-13a2 2 0 0 1 2.63-.17l13.19 10.14A2 2 0 0 1 61.87 52l-11.8-9.11-11.8 11.8a2 2 0 0 1-1.41.59zm77.71 11.98H3.92v4h110.82v-4zm-2.76 17.37H6.85A6.86 6.86 0 0 1 0 77.77V6.85A6.85 6.85 0 0 1 6.85 0h105a6.85 6.85 0 0 1 6.85 6.85v70.92a6.86 6.86 0 0 1-6.89 6.86zM6.85 3.92a2.93 2.93 0 0 0-2.93 2.93v70.92a2.94 2.94 0 0 0 2.93 2.94h105a2.94 2.94 0 0 0 2.93-2.94V6.85a2.93 2.93 0 0 0-2.93-2.93zm11.04 49.36a2.62 2.62 0 0 1-2.62 2.62 2.62 2.62 0 0 1-2.62-2.62 2.62 2.62 0 0 1 2.62-2.62 2.62 2.62 0 0 1 2.62 2.62zm0-9.25a2.62 2.62 0 0 1-2.62 2.62 2.62 2.62 0 0 1-2.62-2.62 2.62 2.62 0 0 1 2.62-2.62 2.62 2.62 0 0 1 2.62 2.62zm0-9.25a2.62 2.62 0 0 1-2.62 2.62 2.62 2.62 0 0 1-2.62-2.62 2.62 2.62 0 0 1 2.62-2.62 2.62 2.62 0 0 1 2.62 2.62zm0-9.25a2.62 2.62 0 0 1-2.62 2.62 2.62 2.62 0 0 1-2.62-2.62 2.62 2.62 0 0 1 2.62-2.62 2.62 2.62 0 0 1 2.62 2.62zm.01-9.25a2.63 2.63 0 1 1-2.63-2.63 2.62 2.62 0 0 1 2.63 2.63zm18.96 13.41a7.5 7.5 0 1 1 7.5-7.5 7.5 7.5 0 0 1-7.5 7.5zm0-11a3.5 3.5 0 1 0 3.5 3.5 3.5 3.5 0 0 0-3.5-3.5zm70.75 36.59h-6.88a2 2 0 1 1 0-4h6.88a2 2 0 0 1 0 4zm0-9.28h-6.88a2 2 0 1 1 0-4h6.88a2 2 0 0 1 0 4zm0-9.22h-6.88a2 2 0 1 1 0-4h6.88a2 2 0 0 1 0 4zm0-9.25h-6.88a2 2 0 0 1 0-4h6.88a2 2 0 0 1 0 4zm0-9.25h-6.88a2 2 0 1 1 0-4h6.88a2 2 0 0 1 0 4zM48.6 84.63h3.92v8.46H48.6zm18.33 0h3.92v8.46h-3.92zM89.73 97h-60.8a2 2 0 0 1 0-3.92h60.8a2 2 0 0 1 0 3.92z"
    />
  </svg>
);

export const CardIcon = (props) => {
  return (
    <svg fillOpacity="0.85" viewBox="0 0 609 609" {...props}>
      <path
        className="svg-icon-color-stroke svg-icon-color-fill"
        d="M538.84 316.89H521.2q-194.86 0-389.73-.07c-5.8 0-11.81-.13-17.36-1.59-9.17-2.4-14.35-10-11.55-18.38 2-6 8.84-11.2 14.74-14.7 3.71-2.2 9.68-.68 14.64-.68h405.59c3.45-24.41-15.3-45.78-40.94-47.69-6.73-.51-13.53-.2-20.29-.2H128.51c-3.6 0-8.29 1.4-10.61-.34-5.9-4.4-13.45-9.4-15.38-15.68-2.8-9.14 3.76-16.29 13.22-18.71 4.26-1.09 9-.55 13.46-.56 120 0 240 .48 360-.24 52.8-.32 86.92 41.91 85.86 85.9-1.79 74.38-.43 148.84-.51 223.27 0 48.77-34.71 83.48-83.43 83.5q-183.36.1-366.73 0c-48.89 0-83.8-34.58-83.86-83.07-.09-75.33.07-150.66-.12-226 0-10.7 2.73-18.89 14.2-21.18 11.82-2.36 20.61 6 20.85 20.23.33 19.4.09 38.8.1 58.19v163.74c0 34.75 17.82 52.76 52.12 52.78q180 .06 360 0c33.69 0 51.73-18 51.8-51.7q.17-86.61 0-173.22c-.05-3.97-.39-7.94-.64-13.6z"
        transform="translate(-3 -90)"
        fill="#fff"
      />
      <path
        className="svg-icon-color-stroke svg-icon-color-fill"
        d="M236.3 436.46c0 13.5.17 27 0 40.49-.22 15-6.18 21.24-21.38 21.39q-41.83.42-83.68 0c-14.49-.18-20.37-6.38-20.47-20.79q-.27-42.51 0-85c.09-14.37 6.09-20.49 20.54-20.62q42.51-.37 85 0c13.43.15 19.66 6.61 19.92 20 .29 14.84.07 29.69.07 44.53zm-36.56 25.88v-54.4h-53.11v54.4zM394.11 452.75c-27.51 0-55 .07-82.54 0-14.66-.05-22.26-6.21-22.28-17.62s7.54-17.62 22.28-17.64q83.91-.13 167.8 0c14.09 0 22.14 7 21.71 18.31-.41 10.72-8 16.87-21.72 16.93-28.42.11-56.83.02-85.25.02z"
        transform="translate(-3 -90)"
        fill="#fff"
      />
    </svg>
  );
};

export const RefreshIcon = (props) => (
  <svg viewBox="0 0 89.17 97" width="1em" height="1em" {...props}>
    <path
      className="svg-icon-color-stroke svg-icon-color-fill"
      d="M44 97a48.25 48.25 0 0 1-15.82-2.66 49.61 49.61 0 0 1-20.91-14L3 82.81a2 2 0 0 1-3-1.71V53.43a2 2 0 0 1 1-1.71 2 2 0 0 1 2 0l24 13.83a2 2 0 0 1 0 3.42l-4.09 2.36A33.22 33.22 0 0 0 34 80.53c5.81 3 13.17 3.77 21.86 2.27a2 2 0 1 1 .67 3.9c-9.56 1.65-17.75.76-24.34-2.65a37.28 37.28 0 0 1-13.88-12.22 2 2 0 0 1-.31-1.55A1.93 1.93 0 0 1 19 69l3-1.75-18-10.4v20.82l2.76-1.6a2 2 0 0 1 2.52.45 45.67 45.67 0 0 0 20.2 14.08 44.25 44.25 0 0 0 27.88.4 42.3 42.3 0 0 0 21.58-15.76 40.17 40.17 0 0 0 6.33-13.75 2 2 0 0 1 3.84 1 44.12 44.12 0 0 1-7 15.08 46.2 46.2 0 0 1-23.6 17.22A48 48 0 0 1 44 97zM87.19 45.55a2.06 2.06 0 0 1-1-.26l-24-13.84a2 2 0 0 1 0-3.42l4.09-2.36a33.22 33.22 0 0 0-11.13-9.2c-5.81-3-13.17-3.77-21.86-2.27a2 2 0 1 1-.67-3.89C42.23 8.66 50.42 9.54 57 13a37.28 37.28 0 0 1 13.86 12.17 2 2 0 0 1 .29 1.55 1.93 1.93 0 0 1-.94 1.28l-3 1.75 18 10.41V19.33l-2.76 1.6a2 2 0 0 1-2.51-.45A45.7 45.7 0 0 0 59.69 6.4 44.29 44.29 0 0 0 31.82 6a42.29 42.29 0 0 0-21.59 15.76A40.36 40.36 0 0 0 3.9 35.51a2 2 0 1 1-3.84-1A44.12 44.12 0 0 1 7 19.47 46.19 46.19 0 0 1 30.61 2.26a48.17 48.17 0 0 1 30.39.4 49.61 49.61 0 0 1 20.91 14l4.31-2.49a2 2 0 0 1 3 1.72v27.68a2 2 0 0 1-1 1.72 2 2 0 0 1-1.03.26z"
    />
  </svg>
);

export const SearchIcon = (props) => (
  <svg viewBox="0 0 16.67 16.26" width="1em" height="1em" {...props}>
    <defs>
      <style>{'.search-svg-icon{stroke-width:0 !important}'}</style>
    </defs>
    <path
      className="search-svg-icon svg-icon-color-stroke svg-icon-color-fill"
      d="M6.65 13.3a6.6 6.6 0 0 0 3.72-1.14L14 15.8a1.51 1.51 0 0 0 1.1.46 1.56 1.56 0 0 0 1.1-2.65l-.2-.27-3.53-3.48a6.65 6.65 0 1 0-5.82 3.44zm9.08 2a.88.88 0 0 1-1.22 0l1.21-1.22a.84.84 0 0 1 .25.6.86.86 0 0 1-.24.63zm-.52-1.73L14 14.79l-3.06-3.06a6.66 6.66 0 0 0 1.16-1.27zM6.65.69a6 6 0 1 1-6 6 6 6 0 0 1 6-6z"
    />
    <path
      className="search-svg-icon svg-icon-color-stroke svg-icon-color-fill"
      d="M6.65 11.44a4.79 4.79 0 1 0-4.79-4.79 4.8 4.8 0 0 0 4.79 4.79zm0-8.89a4.1 4.1 0 1 1-4.1 4.1 4.11 4.11 0 0 1 4.1-4.1z"
    />
  </svg>
);

export const CheckedPaperIcon = (props) => (
  <svg viewBox="0 0 36.17 45" width="1em" height="1em" {...props}>
    <defs>
      <style>{'.cls-1{fill:none;stroke-miterlimit:10;stroke-width:2px}'}</style>
    </defs>
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M33 11V1H1v43h32V34M1 7h32M4 4h2M8 4h2M12 4h2"
    />
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M5 11h11v10H5zM19 12h10M19 17h4M4 26h13M4 31h13M4 36h13M26.84 32a1.66 1.66 0 0 1-1-.32l-6.44-4.86 1.94-2.58 5.24 3.93 7.11-8.53 2.48 2.07-8.09 9.71a1.61 1.61 0 0 1-1.24.58z"
    />
  </svg>
);

export const HourglassIcon = ({ color = undefined, ...props }: { color?: string } & any) => (
  <svg viewBox="0 0 30 48" width="1em" height="1em" {...props}>
    <defs>
      <style>{'.cls-1{fill:none;stroke-miterlimit:10;stroke-width:2px}'}</style>
    </defs>
    <path
      className="cls-1"
      stroke={color}
      d="M26 42v-6.27a9 9 0 0 0-2.64-6.37L17 23l6.36-6.36A9 9 0 0 0 26 10.27V6M4 6v4.27a9 9 0 0 0 2.64 6.37L13 23l-6.36 6.36A9 9 0 0 0 4 35.73V42M29 1H1v3a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2zM27 42H3a2 2 0 0 0-2 2v3h28v-3a2 2 0 0 0-2-2zM22 40c0-2-7-5-7-5s-7 3-7 5M15 26v2M15 30v2"
    />
  </svg>
);

export const LaptopWithChartIcon = (props) => (
  <svg viewBox="0 0 48 36" width="1em" height="1em" {...props}>
    <defs>
      <style>
        {
          '.cls-1,.cls-2{fill:none;stroke-width:2px}.cls-1{stroke-linejoin:round}.cls-2{stroke-miterlimit:10}'
        }
      </style>
    </defs>
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M44 35H4a3 3 0 0 1-3-3v-2h18l1 1h8l1-1h18v2a3 3 0 0 1-3 3zM4 30V3a2 2 0 0 1 2-2h36a2 2 0 0 1 2 2v27"
    />
    <path className="cls-2 svg-icon-color-stroke" d="M14 25V13h4v12M22 25V7h4v18M30 25v-9h4v9" />
  </svg>
);

export const LightbulbIcon = (props) => (
  <svg viewBox="0 0 44 46" width="1em" height="1em" {...props}>
    <defs>
      <style>{'.cls-1{fill:none;stroke-linejoin:round;stroke-width:2px}'}</style>
    </defs>
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M22 0v8M6.44 6.44l5.66 5.66M0 22h8M6.44 37.56l5.66-5.66M37.56 37.56L31.9 31.9M44 22h-8M37.56 6.44L31.9 12.1M26 44h-1l-1 1h-4l-1-1h-1M16 38h12M17 41h10M27 36v-2a6.66 6.66 0 0 1 1.88-4.75A10.12 10.12 0 0 0 32 22a10 10 0 0 0-20 0 10.12 10.12 0 0 0 3.12 7.25A6.66 6.66 0 0 1 17 34v2M22 36v-8M20 28h4M15.11 5.37l1.53 3.7M5.37 15.11l3.7 1.53M5.37 28.89l3.7-1.53M38.63 28.89l-3.7-1.53M38.63 15.11l-3.7 1.53M28.89 5.37l-1.53 3.7"
    />
  </svg>
);

export const HourglassDocumentIcon = (props) => (
  <svg viewBox="0 0 41 46" width="1em" height="1em" {...props}>
    <defs>
      <style>{'.cls-1{fill:none;stroke-miterlimit:10;stroke-width:2px}'}</style>
    </defs>
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M4 38h7M10 1h27a3 3 0 0 1 3 3v41H13V4a3 3 0 0 0-6 0v31a3 3 0 0 1-6 0V10h4"
    />
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M20 34v-3.61a5.86 5.86 0 0 1 1.44-3.89L25 23l-3.56-3.5A5.86 5.86 0 0 1 20 15.61V12M33 34v-3.61a5.86 5.86 0 0 0-1.44-3.89L28 23l3.56-3.5A5.86 5.86 0 0 0 33 15.61V12M17 12h19M17 34h19"
    />
  </svg>
);

export const Tfa1Icon = (props) => (
  <svg viewBox="0 0 40 47.99" width="1em" height="1em" {...props}>
    <defs>
      <style>{'.TfaIcon{fill:none;stroke-linejoin:round;stroke-width:1px}'}</style>
    </defs>
    <path
      className="TfaIcon svg-icon-color-stroke"
      d="M20 1C18.16 3.62 5.84 9 1 9v19c0 8.93 17.94 18.7 19 19 1.06-.29 19-10.74 19-18V9c-5.28 0-17.14-5.38-19-8z"
    />
    <path
      className="TfaIcon svg-icon-color-stroke"
      d="M20 41.33a60.71 60.71 0 0 1-7.3-4.95C7.74 32.45 6 29.41 6 28V13.21a54.66 54.66 0 0 0 14-5.88 53 53 0 0 0 14 5.91V29c-.07.61-1.46 3.22-6.91 7.45A71.93 71.93 0 0 1 20 41.33z"
    />
    <path
      className="TfaIcon svg-icon-color-stroke"
      d="M16 28.59h-5.6v-5.51l.91-.92h2.59l.22-.22v-2.53l-.22-.22h-1.45l-.22.22v1.18h-1.86v-2.32l.91-.92h3.77l.92.92v4.79l-.92.92h-2.6l-.22.22v2.56h1.89v-1.08H16zM22.56 17.35v1.82h-3.5v2.89h2.58v1.81h-2.58v4.72h-1.88V17.35zM26.71 26.17h-2.3l-.51 2.42H22l2.66-11.24h1.84l2.66 11.24h-1.94zm-.37-1.82l-.78-3.79-.78 3.79z"
    />
  </svg>
);

export const InputFieldIcon = (props) => (
  <svg viewBox="0 0 48 29" width="1em" height="1em" {...props}>
    <defs>
      <style>{'.InputFieldIcon{fill:#505050; stroke-width:0.1px}'}</style>
    </defs>
    <path
      className="InputFieldIcon svg-icon-color-stroke svg-icon-color-fill"
      d="M45 25h-3v-2h3a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-3V4h3a3 3 0 0 1 3 3v15a3 3 0 0 1-3 3zM38 25H3a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h35v2H3a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h35zM39 1h2v27h-2z"
    />
    <path
      className="InputFieldIcon svg-icon-color-stroke svg-icon-color-fill"
      d="M37 27h6v2h-6zM37 0h6v2h-6z"
    />
    <path
      className="InputFieldIcon svg-icon-color-stroke svg-icon-color-fill"
      d="M11.77 19.19l-.1-.82a2.43 2.43 0 0 1-2 1 1.86 1.86 0 0 1-2-1.88C7.64 15.89 9 15 11.56 15v-.1a1.34 1.34 0 0 0-1.48-1.51 3.22 3.22 0 0 0-1.7.49l-.27-.79a4 4 0 0 1 2.14-.58c2 0 2.49 1.37 2.49 2.67v2.45a9.23 9.23 0 0 0 .11 1.56zm-.18-3.33c-1.29 0-2.76.2-2.76 1.47a1 1 0 0 0 1.11 1.13 1.62 1.62 0 0 0 1.58-1.09 1.27 1.27 0 0 0 .07-.38zM14.6 19.19c0-.44.06-1.1.06-1.68v-7.9h1.17v4.1a2.44 2.44 0 0 1 2.22-1.2c1.62 0 2.77 1.35 2.76 3.34 0 2.33-1.47 3.49-2.93 3.49a2.33 2.33 0 0 1-2.19-1.23v1.08zm1.23-2.62a2.12 2.12 0 0 0 .06.44 1.82 1.82 0 0 0 1.78 1.39c1.24 0 2-1 2-2.51 0-1.31-.67-2.43-1.94-2.43a1.89 1.89 0 0 0-1.81 1.45 2.22 2.22 0 0 0-.07.49zM27 19a4.35 4.35 0 0 1-1.87.38A3.11 3.11 0 0 1 21.87 16a3.31 3.31 0 0 1 3.5-3.46 4 4 0 0 1 1.65.33l-.27.92a2.77 2.77 0 0 0-1.38-.31 2.26 2.26 0 0 0-2.3 2.47 2.24 2.24 0 0 0 2.26 2.44 3.36 3.36 0 0 0 1.46-.32zM34 9.61v9.58h-1.07v-1.13a2.4 2.4 0 0 1-2.22 1.28c-1.58 0-2.8-1.34-2.8-3.32 0-2.17 1.34-3.51 2.93-3.51a2.19 2.19 0 0 1 2 1v-3.9zm-1.19 5.71a1.71 1.71 0 0 0-.06-.5A1.74 1.74 0 0 0 31 13.44c-1.24 0-2 1.08-2 2.56s.64 2.41 1.92 2.41a1.89 1.89 0 0 0 1.8-1.93z"
    />
  </svg>
);

export const KeysIcon = (props) => (
  <svg viewBox="0 0 44.37 48" width="1em" height="1em" {...props}>
    <defs>
      <style>{'.cls-1{fill:none;stroke-miterlimit:10;stroke-width:2px}'}</style>
    </defs>
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M24.19 7.78a10 10 0 0 0-5 2.73 10.13 10.13 0 0 0-2.72 9.74l-4.13 4v3.06l-.29.67H9l-1.63 1.39v3.06L7 33H3.92l-2.55 2.74L4.43 39h5.1l12-12.25a9.92 9.92 0 0 0 4.8 1.1"
    />
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M28.37 47h4.48l3.52-4.12v-17c5-1.24 7-5.3 7-9.87a10 10 0 0 0-20 0c0 3.73 3 7.18 5 8.93V31l2 1.58v1.62l-2 2.26v1.37l2 1.9v1.58l-2 1.58z"
    />
    <circle className="cls-1 svg-icon-color-stroke" cx={33.37} cy={13} r={3} />
    <path className="cls-1 svg-icon-color-stroke" d="M19.37 8a7 7 0 1 1 14 0v5" />
  </svg>
);

export const MailboxIcon = (props) => (
  <svg viewBox="0 0 48 47" width="1em" height="1em" {...props}>
    <defs>
      <style>{'.cls-1{fill:none;stroke-miterlimit:10;stroke-width:2px}'}</style>
    </defs>
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M3 36H1V20a10 10 0 0 1 10-10h18M31 10h6a10 10 0 0 1 10 10v16H21"
    />
    <path className="cls-1 svg-icon-color-stroke" d="M11 10a10 10 0 0 1 10 10v16" />
    <circle className="cls-1 svg-icon-color-stroke" cx={29} cy={26} r={4} />
    <path
      className="cls-1 svg-icon-color-stroke"
      d="M33 5h4V1h-8v22M24 47V36M30 36v11M21 36H5V20h14"
    />
    <path className="cls-1 svg-icon-color-stroke" d="M8 23l7 6h4M12 29l-4.5 4.5" />
  </svg>
);

export const LockedRackIcon = (props) => (
  <svg viewBox="0 0 15.72 17.84" width="1em" height="1em" {...props}>
    <defs>
      <style>{'.locked-rack-icon{fill:none;stroke-linejoin:round;stroke-width:0.1px}'}</style>
    </defs>
    <path
      className="locked-rack-icon svg-icon-color-stroke svg-icon-color-fill"
      d="M2.57 5h8.63a2.49 2.49 0 1 0 0-5H2.57a2.49 2.49 0 1 0 0 5zm0-4.28h8.63a1.8 1.8 0 1 1 0 3.59H2.57a1.8 1.8 0 0 1 0-3.59zM11 17.84h3.49a1.2 1.2 0 0 0 1.2-1.2v-3.58a.35.35 0 0 0-.34-.35h-.7v-1.12A1.87 1.87 0 0 0 13 9.77a2.48 2.48 0 0 0-1.7-4.29H2.65a2.49 2.49 0 0 0 0 5h8.63A1.83 1.83 0 0 0 11 11H2.49a2.49 2.49 0 1 0 0 5h7.34v.71A1.2 1.2 0 0 0 11 17.84zm4-1.2a.51.51 0 0 1-.51.51H11a.51.51 0 0 1-.51-.51v-3.23H15zm-1-5.05v1.12h-2.44v-1.12a1.22 1.22 0 0 1 2.43 0zM.86 8a1.8 1.8 0 0 1 1.79-1.8h8.64a1.8 1.8 0 0 1 0 3.59H2.65A1.8 1.8 0 0 1 .86 8zm1.63 7.27a1.8 1.8 0 1 1 0-3.59h8.38v1.06h-.7a.35.35 0 0 0-.34.35v2.18z"
    />
    <path
      className="locked-rack-icon svg-icon-color-stroke svg-icon-color-fill"
      d="M12.78 13.74a1 1 0 0 0-1 1 1 1 0 0 0 .68 1v.66a.35.35 0 0 0 .69 0v-.66a1 1 0 0 0-.34-2zm0 .69a.34.34 0 1 1-.34.34.34.34 0 0 1 .34-.34z"
    />
    <circle
      className="locked-rack-icon svg-icon-color-stroke svg-icon-color-fill"
      cx={10.79}
      cy={2.49}
      r={0.79}
    />
    <path
      className="locked-rack-icon svg-icon-color-stroke svg-icon-color-fill"
      d="M11.75 8a.79.79 0 1 0-.79.78.79.79 0 0 0 .79-.78z"
    />
  </svg>
);

export const QRCode1Icon = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 401.994 401.994" {...props}>
    <path
      className="svg-icon-color-stroke svg-icon-color-fill"
      d="M0 401.991h182.724V219.265H0v182.726zm36.542-146.178h109.636v109.352H36.542V255.813z"
    />
    <path
      className="svg-icon-color-stroke svg-icon-color-fill"
      d="M73.089 292.355h36.544v36.549H73.089zM292.352 365.449h36.553v36.545h-36.553zM365.442 365.449h36.552v36.545h-36.552z"
    />
    <path
      className="svg-icon-color-stroke svg-icon-color-fill"
      d="M365.446 255.813h-36.542v-36.548H219.265v182.726h36.548V292.355h36.539v36.549h109.639V219.265h-36.545zM0 182.728h182.724V0H0v182.728zM36.542 36.542h109.636v109.636H36.542V36.542z"
    />
    <path
      className="svg-icon-color-stroke svg-icon-color-fill"
      d="M73.089 73.089h36.544v36.547H73.089zM219.265 0v182.728h182.729V0H219.265zm146.181 146.178H255.813V36.542h109.633v109.636z"
    />
    <path
      className="svg-icon-color-stroke svg-icon-color-fill"
      d="M292.352 73.089h36.553v36.547h-36.553z"
    />
  </svg>
);

export const QRCode2Icon = (props) => (
  <svg viewBox="0 0 1000 1000" width="1em" height="1em" {...props}>
    <path
      className="svg-icon-color-stroke svg-icon-color-fill"
      d="M147.8 147.8h76.6v76.6h-76.6v-76.6z"
    />
    <path
      className="svg-icon-color-stroke svg-icon-color-fill"
      d="M362.2 10H10v352.2h137.8v61.3h76.6v-61.3h137.8v-76.6h61.3v-61.3h-61.3V10zm-76.6 275.6h-199v-199h199.1v199zM147.8 775.6h76.6v76.6h-76.6v-76.6zM775.6 147.8h76.6v76.6h-76.6v-76.6zM500 493.8v82.7h76.6V500h61.2v-76.6h-61.2v-61.3H500v131.7zM500 773.8v78.4h76.6V714.3h61.2v-76.6H500v136.1zM576.6 852.2h61.2v61.3h-61.2v-61.3zM423.4 913.4V990h153.2v-76.6H423.4z"
    />
    <path
      className="svg-icon-color-stroke svg-icon-color-fill"
      d="M714.4 714.4h-76.6v137.9h137.8v-76.6h-61.3v-61.3zM775.6 990H990v-76.6H852.2v-61.3h-76.6V990zM990 500v-76.6H852.2V500H990zM913.4 775.6H990v76.6h-76.6v-76.6zM423.4 285.6H500v76.6h-76.6v-76.6zM775.6 423.4v-61.3H990V10H637.8v76.6H500v61.3h137.8v76.6h-61.2v61.3h61.2v76.6h76.6v61.2l61.2-.2zM714.4 86.6h199.1v199.1H714.4V86.6zM714.4 576.6h61.3v61.2h-61.3v-61.2z"
    />
    <path
      className="svg-icon-color-stroke svg-icon-color-fill"
      d="M852.2 714.4h-76.6v61.3h137.8V637.9H990v-61.2H852.2v137.7zM423.4 147.8H500v76.6h-76.6v-76.6zM224.4 500h61.3v76.6h-61.3V500z"
    />
    <path
      className="svg-icon-color-stroke svg-icon-color-fill"
      d="M423.4 423.4H285.6V500h76.6v76.6h61.2V423.4zM362.2 852.2V714.4h61.2v-76.6H147.8V500H10v76.6h76.6v61.2H10V990h352.2v-76.6h61.2v-61.3h-61.2zm-76.6 61.2h-199v-199h199.1v199zM423.4 576.6H500v61.2h-76.6v-61.2zM637.8 500h76.6v76.6h-76.6V500zM775.6 500h76.6v76.6h-76.6V500z"
    />
  </svg>
);

export const LockIcon = (props) => (
  <svg viewBox="0 -1 12.73 19" width="1em" height="1em" {...props}>
    <path
      className="svg-icon-color-stroke svg-icon-color-fill"
      strokeWidth={0.4}
      d="M2.32 17.79h8.09a2.32 2.32 0 0 0 2.32-2.32V7.18a.35.35 0 0 0-.34-.35h-2.07V3.78A3.87 3.87 0 0 0 6.37 0a3.87 3.87 0 0 0-3.95 3.78v3.05H.35a.35.35 0 0 0-.35.35v8.29a2.32 2.32 0 0 0 2.32 2.32zm.79-14A3.18 3.18 0 0 1 6.37.69a3.18 3.18 0 0 1 3.25 3.09v3.05H3.11zM.69 7.53H12v7.94a1.63 1.63 0 0 1-1.63 1.63H2.32a1.63 1.63 0 0 1-1.63-1.63z"
    />
    <path
      className="svg-icon-color-stroke svg-icon-color-fill"
      d="M6 13v1.86a.35.35 0 0 0 .35.35.35.35 0 0 0 .34-.35V13A1.93 1.93 0 1 0 6 13zm.37-3.1a1.23 1.23 0 1 1-1.23 1.23A1.23 1.23 0 0 1 6.37 9.9z"
    />
  </svg>
);

export const CoinIcon = (props) => (
  <svg viewBox="0 0 97 97" width="1em" height="1em" {...props}>
    <path
      className="svg-icon-color-stroke svg-icon-color-fill"
      d="M48.5 97A48.5 48.5 0 1 1 97 48.5 48.56 48.56 0 0 1 48.5 97zm0-93A44.5 44.5 0 1 0 93 48.5 44.55 44.55 0 0 0 48.5 4z"
    />
    <path
      className="svg-icon-color-stroke svg-icon-color-fill"
      d="M48.5 84.32A35.82 35.82 0 1 1 84.32 48.5 35.86 35.86 0 0 1 48.5 84.32zm0-67.64A31.82 31.82 0 1 0 80.32 48.5 31.86 31.86 0 0 0 48.5 16.68z"
    />
    <path
      className="svg-icon-color-stroke svg-icon-color-fill"
      d="M51 8.36a2.45 2.45 0 1 1-2.5-2.45A2.45 2.45 0 0 1 51 8.36zM30.55 12.52a2.45 2.45 0 1 1-3.34-.9 2.44 2.44 0 0 1 3.34.9zM15 26.31a2.45 2.45 0 1 1-3.35.9 2.45 2.45 0 0 1 3.35-.9zM8.36 46.05a2.45 2.45 0 1 1-2.45 2.45 2.45 2.45 0 0 1 2.45-2.45zM12.52 66.45a2.45 2.45 0 1 1-.9 3.34 2.44 2.44 0 0 1 .9-3.34zM26.31 82a2.45 2.45 0 1 1 .9 3.35 2.45 2.45 0 0 1-.9-3.35zM46.05 88.64a2.45 2.45 0 1 1 2.45 2.45 2.45 2.45 0 0 1-2.45-2.45zM66.45 84.48a2.45 2.45 0 1 1 3.34.9 2.44 2.44 0 0 1-3.34-.9zM82 70.69a2.45 2.45 0 1 1 3.35-.9 2.45 2.45 0 0 1-3.35.9zM88.64 51a2.45 2.45 0 1 1 2.45-2.45A2.45 2.45 0 0 1 88.64 51zM84.48 30.55a2.45 2.45 0 1 1 .9-3.34 2.44 2.44 0 0 1-.9 3.34zM70.69 15a2.45 2.45 0 1 1-.9-3.35 2.45 2.45 0 0 1 .9 3.35z"
    />
  </svg>
);

export const WarningIcon = (props) => (
  <svg viewBox="0 0 294.995 294.995" width="1em" height="1em" {...props}>
    <path
      className="svg-icon-color-stroke svg-icon-color-fill"
      d="M291.874 248.279L165.605 26.526c-4.007-7.037-10.776-11.26-18.107-11.26s-14.101 4.202-18.107 11.239L3.121 248.238c-3.979 6.989-4.164 15.013-.493 21.326 3.67 6.313 10.663 10.165 18.705 10.165h252.329c8.042 0 15.035-3.852 18.705-10.165 3.671-6.313 3.487-14.296-.493-21.285zM146.665 86.229c9.665 0 17.5 7.835 17.5 17.5v63c0 9.665-7.835 17.5-17.5 17.5s-17.5-7.835-17.5-17.5v-63c0-9.665 7.835-17.5 17.5-17.5zm.833 117.776c9.665 0 17.5 7.835 17.5 17.5s-7.835 17.5-17.5 17.5-17.5-7.835-17.5-17.5 7.835-17.5 17.5-17.5z"
    />
  </svg>
);

export const Tfa2Icon = (props) => (
  <svg viewBox="0 0 15.96 15.32" width="1em" height="1em" {...props}>
    <path
      className="svg-icon-color-stroke svg-icon-color-fill"
      strokeWidth={0.1}
      d="M10.21 2.23A2.23 2.23 0 1 0 8 4.46a2.23 2.23 0 0 0 2.21-2.23zm-3.76 0A1.54 1.54 0 1 1 8 3.76a1.54 1.54 0 0 1-1.55-1.53zM13.73 0A2.23 2.23 0 1 0 16 2.23 2.23 2.23 0 0 0 13.73 0zm0 3.76a1.54 1.54 0 1 1 1.54-1.53 1.54 1.54 0 0 1-1.54 1.53zM2.23 5.43a2.23 2.23 0 1 0 2.23 2.23 2.23 2.23 0 0 0-2.23-2.23zm0 3.76a1.54 1.54 0 1 1 1.53-1.53 1.54 1.54 0 0 1-1.53 1.53zM13.73 5.43A2.23 2.23 0 1 0 16 7.66a2.23 2.23 0 0 0-2.27-2.23zm0 3.76a1.54 1.54 0 1 1 1.54-1.53 1.54 1.54 0 0 1-1.54 1.53zM2.23 10.86a2.23 2.23 0 1 0 2.23 2.23 2.23 2.23 0 0 0-2.23-2.23zm0 3.76a1.54 1.54 0 1 1 1.53-1.53 1.54 1.54 0 0 1-1.53 1.53zM5.75 13.09A2.23 2.23 0 1 0 8 10.86a2.23 2.23 0 0 0-2.25 2.23zm3.77 0A1.54 1.54 0 1 1 8 11.55a1.54 1.54 0 0 1 1.52 1.54z"
    />
    <path
      className="svg-icon-color-stroke svg-icon-color-fill"
      strokeWidth={0.1}
      d="M13.73 15.32a2.23 2.23 0 0 0 0-4.46 2.18 2.18 0 0 0-1.36.47L9.82 8.92A2.23 2.23 0 0 0 8 5.43a2.18 2.18 0 0 0-1.36.47L4.07 3.49a2.26 2.26 0 0 0 .39-1.26A2.24 2.24 0 1 0 3.59 4l2.55 2.4a2.26 2.26 0 0 0-.39 1.26 2.22 2.22 0 0 0 3.59 1.76l2.56 2.41a2.19 2.19 0 0 0-.39 1.26 2.23 2.23 0 0 0 2.22 2.23zm0-3.77a1.54 1.54 0 1 1-1.53 1.54 1.56 1.56 0 0 1 .21-.77l.56.52a.69.69 0 0 0 0 .25.81.81 0 1 0 .8-.81.72.72 0 0 0-.29.06l-.55-.53a1.52 1.52 0 0 1 .8-.26zM8 6.12a1.54 1.54 0 0 1 1.52 1.54 1.57 1.57 0 0 1-.22.77l-.55-.53a1 1 0 0 0 0-.24.81.81 0 0 0-.75-.81.72.72 0 0 0-.29.06l-.56-.53A1.58 1.58 0 0 1 8 6.12zM2.23 3.76a1.54 1.54 0 1 1 1.53-1.53 1.56 1.56 0 0 1-.21.77L3 2.47a.64.64 0 0 0 0-.24.81.81 0 1 0-.77.77.94.94 0 0 0 .29 0l.56.53a1.57 1.57 0 0 1-.85.23zM8 9.19a1.54 1.54 0 0 1-1.55-1.53 1.56 1.56 0 0 1 .21-.77l.56.52a.69.69 0 0 0 0 .25.8.8 0 0 0 .8.8.93.93 0 0 0 .29-.05l.56.53a1.54 1.54 0 0 1-.87.25z"
    />
  </svg>
);

export const QuestionmarkIcon = (props) => (
  <svg viewBox="0 0 475 475" width="1em" height="1em" {...props}>
    <path
      className="svg-icon-color-stroke svg-icon-color-fill"
      d="M238 0C107 0 0 107 0 238s107 237 238 237 237-106 237-237S369 0 238 0zm0 432c-107 0-194-87-194-194S131 44 238 44s194 87 194 194-87 194-194 194z"
    />
    <path
      className="svg-icon-color-stroke svg-icon-color-fill"
      d="M236 89c-80 0-98 59-98 82 0 12 10 21 22 21s22-9 22-21c0-9 5-39 54-39 24 0 42 7 53 19 14 15 13 35 12 43-3 23-15 35-38 35-40 0-49 22-49 40v18c0 12 10 22 22 22s22-10 22-22v-14c1 0 3-1 5-1 35 0 75-19 81-73 3-29-4-57-22-77-13-15-40-33-86-33zM236 331c-15 0-27 12-27 27s12 27 27 27 27-12 27-27-12-27-27-27z"
    />
  </svg>
);

export const LifeVestIcon = (props) => (
  <svg viewBox="0 0 38 38" width="1em" height="1em" {...props}>
    <path
      className="svg-icon-color-stroke svg-icon-color-fill"
      strokeWidth={0.1}
      d="M38 19C38 8.5 29.5 0 19 0S0 8.5 0 19s8.5 19 19 19 19-8.5 19-19zm-3.7 6.5l-4.4-1.9c1.2-2.9 1.2-6.3 0-9.2l4.4-1.8c1.8 4 1.8 8.8 0 12.9zM14.4 8.1l-1.9-4.4c2.1-.9 4.2-1.3 6.5-1.3 2.2 0 4.4.4 6.5 1.3l-1.9 4.4c-1.5-.6-3-.9-4.6-.9-1.6-.1-3.2.2-4.6.9zM2.4 19c0-2.2.4-4.4 1.3-6.5l4.4 1.8c-1.2 2.9-1.2 6.3 0 9.2l-4.4 1.9c-.9-2-1.3-4.2-1.3-6.4zm7.1 0c0-5.2 4.3-9.5 9.5-9.5s9.5 4.3 9.5 9.5-4.3 9.5-9.5 9.5-9.5-4.3-9.5-9.5zm4.9 10.9c1.5.6 3 .9 4.6.9 1.6 0 3.2-.3 4.6-.9l1.9 4.4c-2.1.9-4.2 1.3-6.5 1.3-2.2 0-4.4-.4-6.5-1.3l1.9-4.4z"
    />
  </svg>
);

export const ArrowDownIcon = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 451.847 451.847" {...props}>
    <path
      className="svg-icon-color-stroke svg-icon-color-fill"
      d="M225.923 354.706c-8.098 0-16.195-3.092-22.369-9.263L9.27 151.157c-12.359-12.359-12.359-32.397 0-44.751 12.354-12.354 32.388-12.354 44.748 0l171.905 171.915 171.906-171.909c12.359-12.354 32.391-12.354 44.744 0 12.365 12.354 12.365 32.392 0 44.751L248.292 345.449c-6.177 6.172-14.274 9.257-22.369 9.257z"
    />
  </svg>
);

export const ArrowUpIcon = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 451.847 451.846" {...props}>
    <path
      className="svg-icon-color-stroke svg-icon-color-fill"
      d="M248.292 106.406l194.281 194.29c12.365 12.359 12.365 32.391 0 44.744-12.354 12.354-32.391 12.354-44.744 0L225.923 173.529 54.018 345.44c-12.36 12.354-32.395 12.354-44.748 0-12.359-12.354-12.359-32.391 0-44.75L203.554 106.4c6.18-6.174 14.271-9.259 22.369-9.259 8.095 0 16.192 3.091 22.369 9.265z"
    />
  </svg>
);

export const CheckIcon = ({ color = 'white', ...props }: { color?: string } & any) => (
  <svg x="0px" y="0px" viewBox="0 0 1280 1280" {...props}>
    <defs>
      <style>{'enable-background:new 0 0 1280 1280;'}</style>
    </defs>
    <polygon
      fill={color}
      points="946.3,152.6 520.9,691.7 324.6,536.8 156,750.5 352.3,905.4 352,905.7 565.7,1074.4 1160,321.2 "
    />
  </svg>
);

export const FailIcon = ({ color = 'red', ...props }: { color?: string } & any) => (
  <svg version="1.1" viewBox="0 0 1280 1280" {...props}>
    <defs>
      <style>{'enable-background:new 0 0 1280 1280;'}</style>
    </defs>
    <path
      d="m406 173.47-191.89 194.3 250.8 250.8-252 252 194.3 191.89 250.8-250.8 252 252 191.89-194.3-250.8-250.8 252-252-194.3-191.89-250.8 250.8z"
      fill={color}
    />
  </svg>
);

export const CloseIcon = ({ color = undefined, ...props }) => (
  <svg viewBox="0 0 60 60" {...props}>
    <g fill="none" stroke="#000" strokeWidth={10} strokeMiterlimit={10} strokeLinecap="round">
      <path
        fill={color}
        className="svg-icon-color-stroke svg-icon-color-fill"
        d="M10 10l45 45M10 55l45-45"
      />
    </g>
  </svg>
);

export const LoginIcon = (props) => (
  <svg height="512pt" viewBox="0 0 512 512" width="512pt" {...props}>
    <path
      className="svg-icon-color-stroke svg-icon-color-fill"
      d="M218.668 240H16c-8.832 0-16-7.168-16-16s7.168-16 16-16h202.668c8.832 0 16 7.168 16 16s-7.168 16-16 16zm0 0"
    />
    <path
      className="svg-icon-color-stroke svg-icon-color-fill"
      d="M138.668 320a15.89 15.89 0 0 1-11.309-4.691c-6.25-6.254-6.25-16.387 0-22.637l68.696-68.692-68.696-68.671c-6.25-6.254-6.25-16.387 0-22.637s16.383-6.25 22.637 0l80 80c6.25 6.25 6.25 16.383 0 22.637l-80 80A15.975 15.975 0 0 1 138.668 320zm0 0M341.332 512c-23.531 0-42.664-19.137-42.664-42.668v-384c0-18.238 11.605-34.516 28.883-40.512L455.723 2.09C484.395-6.7 512 14.57 512 42.668v384c0 18.219-11.605 34.473-28.863 40.488L354.922 509.91c-4.672 1.45-9 2.09-13.59 2.09zm128-480c-1.387 0-2.559.172-3.816.555L337.879 75.113c-4.184 1.453-7.211 5.676-7.211 10.219v384c0 7.277 7.89 12.184 14.484 10.113l127.637-42.558c4.16-1.453 7.211-5.676 7.211-10.219v-384C480 36.801 475.223 32 469.332 32zm0 0"
    />
    <path
      className="svg-icon-color-stroke svg-icon-color-fill"
      d="M186.668 106.668c-8.832 0-16-7.168-16-16v-32c0-32.363 26.3-58.668 58.664-58.668h240c8.832 0 16 7.168 16 16s-7.168 16-16 16h-240c-14.7 0-26.664 11.969-26.664 26.668v32c0 8.832-7.168 16-16 16zm0 0M314.668 448h-85.336c-32.363 0-58.664-26.305-58.664-58.668v-32c0-8.832 7.168-16 16-16s16 7.168 16 16v32c0 14.7 11.965 26.668 26.664 26.668h85.336c8.832 0 16 7.168 16 16s-7.168 16-16 16zm0 0"
    />
  </svg>
);

export type ISortOrderDirection = 'ASC' | 'DESC';
const $SortOrderIconBar = styled.rect`
  transition: y 0.1s ease-in-out;
`;

export const SortOrderIcon = ({ direction = 'ASC', ...props }) => {
  let y = 0;
  let deltaY = 10;
  if (direction === 'DESC') {
    y = 30;
    deltaY *= -1;
  }

  return (
    <svg viewBox="0 0 40 40" width="1rem" style={{ transition: 'all 0.1s' }} {...props}>
      <$SortOrderIconBar
        key={1}
        className="svg-icon-color-stroke svg-icon-color-fill"
        x={0}
        y={y}
        width={40}
        height={5}
      />
      <$SortOrderIconBar
        key={2}
        className="svg-icon-color-stroke svg-icon-color-fill"
        x={5}
        y={(y += deltaY)}
        width={30}
        height={5}
      />
      <$SortOrderIconBar
        key={3}
        className="svg-icon-color-stroke svg-icon-color-fill"
        x={10}
        y={(y += deltaY)}
        width={20}
        height={5}
      />
      <$SortOrderIconBar
        key={4}
        className="svg-icon-color-stroke svg-icon-color-fill"
        x={15}
        y={(y += deltaY)}
        width={10}
        height={5}
      />
    </svg>
  );
};

export const TwoCircularArrowsIcon = (props) => {
  return (
    <svg viewBox="0 0 1000 1000" width="1rem" enableBackground="new 0 0 1000 1000" {...props}>
      <g>
        <g>
          <g id="_x37__22_">
            <g>
              <path
                className="svg-icon-color-stroke svg-icon-color-fill"
                d="M980,438.8h-56C894.2,231.2,716.2,71.5,500.3,71.5c-166.8,0-310.9,95.5-381.8,234.6l115,44.2C286,257,385.7,193.9,500.4,193.9c148.1,0,271.6,105.2,299.9,244.9h-73.8c-9.5,9.2-18.5,14.9-5,30.8l114.2,116.1c9.5,9.2,24.8,9.2,34.2,0l115-116.1C994.4,460.4,989.4,448,980,438.8z M500.3,806.1c-137,0-253-90.1-292-214.2h67c9.5-9.2,14.4-21.6,5-30.8L165.3,444.9c-9.5-9.2-24.8-9.2-34.2,0L16.9,561c-13.6,15.9-4.5,21.6,5,30.8H78c33.2,181.6,209.4,336.7,422.4,336.7c155.9,0,291.9-83.5,366.9-208l-115.8-45.7C696.1,754.1,604.3,806.1,500.3,806.1z"
              />
            </g>
          </g>
        </g>
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
      </g>
    </svg>
  );
};

export const CrossCuttingArrowsIcon = (props) => {
  return (
    <svg
      x="0px"
      y="0px"
      viewBox="0 0 495.795 495.795"
      enableBackground="new 0 0 495.795 495.795;"
      className="svg-icon-color-stroke svg-icon-color-fill"
      width="1rem"
      {...props}
    >
      <g>
        <path
          d="M479.751,134.804L346.7,1.763c-1.711-1.719-4.291-2.235-6.553-1.308c-2.242,0.937-3.711,3.132-3.711,5.561
  v64.328H206.921c-8.215,0-14.863,6.659-14.863,14.866v107.702c0,8.207,6.648,14.865,14.863,14.865h129.516v64.329
  c0,2.429,1.469,4.624,3.711,5.561c2.262,0.926,4.842,0.411,6.553-1.308l133.051-133.05c1.131-1.13,1.774-2.656,1.774-4.252
  C481.525,137.46,480.882,135.935,479.751,134.804z"
        />
        <path
          d="M288.858,288.019H159.36v-64.33c0-2.428-1.469-4.622-3.711-5.559c-2.261-0.927-4.844-0.412-6.553,1.307
  L16.047,352.478c-1.13,1.13-1.776,2.656-1.776,4.252c0,1.598,0.646,3.124,1.776,4.254l133.05,133.048
  c1.709,1.719,4.292,2.236,6.553,1.308c2.242-0.936,3.711-3.13,3.711-5.56v-64.33h129.498c8.216,0,14.863-6.657,14.863-14.864
  V302.883C303.721,294.678,297.074,288.019,288.858,288.019z"
        />
      </g>
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>
  );
};

export const VolumeIcon = (props) => {
  return (
    <svg
      viewBox="0 0 34.278 33.23"
      className="svg-icon-color-stroke svg-icon-color-fill"
      width="1rem"
      {...props}
    >
      <path
        style={{
          lineHeight: 'normal',
          whiteSpace: 'normal',
          isolation: 'auto',
          mixBlendMode: 'normal',
        }}
        d="M1.446 0A1.44 1.44 0 00.024 1.701l5.512 29.902a1.44 1.44 0 000 .002 1.44 1.44 0 00.427 1 1.44 1.44 0 00.082.075 1.44 1.44 0 00.041.037 1.44 1.44 0 00.03.021 1.44 1.44 0 001.122.285h17.293a1.44 1.44 0 001.426-1.238L29.383 7.53l4.213-4.842a1.44 1.44 0 00.436-1.482 1.44 1.44 0 00-.04-.117 1.44 1.44 0 00-.005-.02 1.44 1.44 0 00-.007-.013 1.44 1.44 0 00-.026-.063 1.44 1.44 0 00-.042-.084A1.44 1.44 0 0033.91.9 1.44 1.44 0 0033.9.888a1.44 1.44 0 00-1.457-.726zM3.17 2.889l26.315.138-2.555 2.934a1.44 1.44 0 00-.34.744l-3.309 23.44H8.194l-1.019-5.526h8.349a1.262 1.262 0 100-2.524H6.84a1.262 1.262 0 00-.129.004l-.829-4.496 9.657-.123a1.262 1.262 0 10-.03-2.523l-10.09.128-.767-4.16 10.886-.116a1.262 1.262 0 10-.028-2.524l-11.323.121z"
        color="#000"
        overflow="visible"
      />
    </svg>
  );
};

export const MasterCard = (props) => {
  return (
    <svg
      id="prefix__Layer_1"
      data-name="Layer 1"
      viewBox="0 0 612 367.2"
      width="1em"
      height="1em"
      {...props}
    >
      <defs>
        <style>
          {
            '.prefix__cls-4{fill:#fdfcfc}.prefix__cls-5{fill:#fdfcfd}.prefix__cls-7{fill:#050466}.prefix__cls-8{fill:#050366}.prefix__cls-10{fill:#060467}.prefix__cls-11{fill:#080567}.prefix__cls-13{fill:#090566}.prefix__cls-15{fill:#fdfdfd}.prefix__cls-17{fill:#060567}.prefix__cls-18{fill:#090869}.prefix__cls-19{fill:#fef1de}.prefix__cls-20{fill:#ca0203}.prefix__cls-22{fill:#fd9802}.prefix__cls-23{fill:#fe9f10}'
          }
        </style>
      </defs>
      <title>{'mastercard'}</title>
      <path
        d="M306.3 572.68c-3.43 2.75-6.82 5.55-10.28 8.26-25.14 19.64-53.51 32.06-85.08 36.4-48.5 6.66-93.06-4-132.66-32.93C39.43 556 15.13 517.83 6.94 470.44c-9.64-55.79 4.11-105.92 40.73-149.24 24.35-28.81 55.24-47.78 91.79-57.31a178.24 178.24 0 0178-2.77c33.34 6.11 62.62 20.64 87.93 43.15a5.31 5.31 0 00.63.42 14.72 14.72 0 01-1.52 2.19c-3.69 3.63-7.47 7.16-11.13 10.83-1.68 1.68-3.15 3.58-5.07 5.79h24.89c3.56 0 7.67-1 10.53.47s4.8 5.31 7 8.24c2.44 3.3 4.69 6.73 7.38 10.63h-3.47c-18.44 0-36.88.12-55.32-.1-4-.05-6.43.87-8.14 4.59-2.21 4.81-4.94 9.38-7.64 14.41H267c25.16 0 50.31.14 75.47-.13 4.59-.05 7.12 1.07 8.48 5.55 1.41 4.64 3.45 9.08 5.34 13.94h-96.98a6.86 6.86 0 00-2 .05c-.62.2-1.47.65-1.63 1.17-1.69 5.75-3.27 11.53-5 17.74h110.89c.57 3.71 1.09 7.14 1.61 10.56-8.7-1.77-13.18 4.25-18.24 10.49.55-3.78 1-6.74 1.42-9.79h-17.78l-1.16 5.81h-4c-4 24.9-8 49.57-12 74.52h14.36c5.72 0 5.72 0 6.33-5.69a5.54 5.54 0 011.5-.15c2.23.38 2.81-.66 3.1-2.75 1.05-7.46 2.17-14.92 3.59-22.32 1.22-6.37 2.89-12.66 4.36-19a20.55 20.55 0 013-1.85c5.23-2.11 7.12-.72 6.62 4.51-1.18 12.31-.17 24.22 6.74 35-1.31 4.54-2.75 9.05-3.87 13.64-.54 2.25-1.56 2.86-3.82 2.85q-46.9-.11-93.8-.05h-3.2a22.41 22.41 0 00.61 2.36c1.89 4.81 3.86 9.59 5.68 14.42.7 1.88 1.77 2.45 3.79 2.44q39.38-.11 78.76-.05h3.71c-3.41 6.13-6.55 11.63-9.53 17.21a3.72 3.72 0 01-3.8 2.18c-19.2-.07-38.41 0-57.61 0h-3.41c.68 1.2 1 2 1.5 2.61 3.37 4.68 6.79 9.32 10.14 14a4.16 4.16 0 003.84 1.89c10.53-.08 21.07 0 31.6 0h2.57l.36.84q-8 8.19-15.91 16.41c-.76.78-1.54 1.66-2.33 2.53zM262.71 426c-2.19 3.16-4.81 6.1-6.51 9.51-5.13 10.34-6.33 21.36-4.69 32.73a42.47 42.47 0 01-6.54.45c-3.49-.26-5.09-2.35-4.75-5.84.21-2.18.64-4.34 1-6.51q1.78-10.34 3.57-20.7H252c.23-2.15.44-4.13.65-6.11l3.21-.31c.81-6.05 1.6-11.89 2.41-18h-9.52c.63-3.85 1.21-7.45 1.83-11.23h-13.3c-5.7 0-5.7 0-7 5.4a1.88 1.88 0 01-.24.44c-3.72-.13-3.8-.14-4.42 3.36-1.8 10.24-3.54 20.48-5.31 30.73q-1.51 8.71-3 17.44c-1.48-8.46-7-13.31-14.52-16.51a22.91 22.91 0 01-5.73-3.15c-1.13-.95-1.56-2.74-2.3-4.15h18.55l.89-5.67h4.13c.79-5.56 1.57-11.05 2.36-16.58a3.67 3.67 0 00-1-.46c-7.09-.38-14.22-1.31-21.27-1-9.08.46-17 3.85-21.61 12.47-.71.54-1.65.93-2.1 1.64-1.5 2.32-2.82 4.75-4.21 7.14-.06-.59-.11-1.18-.18-1.77-1.34-11.08-7.37-17.45-18.33-19.25-8.95-1.47-17.7-.31-26.41 1.85-3.48.87-5.89 2.23-5.74 6.21-1.45.72-3.92 1.19-4.17 2.21-1.22 5-1.85 10.09-2.69 15.14.43.09.61.19.75.15.75-.17 1.48-.38 2.22-.58a62.14 62.14 0 0123.69-2c3 .38 5.71 1.25 6.4 4.77h-2.52a51 51 0 00-18.39 3c-5.55 2.09-9.77 5.87-13.4 10.41a14.33 14.33 0 00-2.51 2.4c-1.78 2.78-3.38 5.68-5 8.53a12.12 12.12 0 010-2q4.41-26.7 8.86-53.39c.68-4.14 1.34-8.29 2.06-12.69H91.25c-2.12 0-4.67-.65-6.23.3-1.39.84-1.68 3.49-2.46 5.34-3.81-.15-3.8-.14-5 3.53l-12 36c0-.76-.14-1.52-.15-2.28q-.33-20.1-.64-40.2c0-.82-.09-1.64-.16-2.7H42.79c-6.18 0-6.18 0-7.31 5.9a19.41 19.41 0 01-2.29 0c-1.8-.25-2.39.41-2.7 2.28-4.28 25.87-8.68 51.72-13 77.58-.65 3.81-1.22 7.63-1.85 11.64h19l1-5.7 4-.23c.88-5.22 1.72-10.3 2.61-15.39 1.48-8.49 3-17 4.5-25.46l1.32 46.92h7.47c6 0 6 0 7.75-5.85 2.46.38 3.5-.84 4.17-3.12 1.09-3.72 2.55-7.34 3.88-11q5.88-16.22 11.77-32.4a21.62 21.62 0 01-.12 2.28q-2.88 18.28-5.8 36.58c-.7 4.39-1.36 8.78-2.07 13.37h19.6c.35-1.92.7-3.82 1-5.72l4-.21c.92-5.39 1.82-10.65 2.72-15.9.17 1.3.45 2.59.51 3.89.48 10.45 5.68 17.45 14.77 19 7.73 1.29 14.87-.45 20.86-5.82l2.16-1.9v6.55h11.35c5.66 0 5.66 0 6.35-5.66h3.76c-.18 1.42-.36 2.83-.56 4.45a13.47 13.47 0 002.87.88c7.51.55 15 1.26 22.54 1.41a27.12 27.12 0 0014.95-3.88c2.72-1.66 5.45-3.42 6.56-6.7l6.52-7.5c0 1.94 0 3.89.13 5.82.61 6.86 5 11.94 11.85 12.46a56.66 56.66 0 0013.53-1.06c4.45-.74 4.4-1 4.73-5.52a6.35 6.35 0 011.4-.5c2.4-.22 3.32-1.52 3.55-3.88.36-3.59 1.09-7.14 1.66-10.71.28.7.6 1.39.83 2.11 3.27 10.06 10.21 16.18 20.4 18.6 9.26 2.2 18.5 1.32 27.74-.47 3.56-.68 5.66-2.23 5.52-6 1-.61 2.83-1.06 3-1.86 1.28-5.76 2.24-11.6 3.29-17.37-.3-.1-.39-.17-.44-.15l-2.15.74c-7.45 2.49-15 4.59-22.93 3.25-5.49-.92-10.08-3.11-11.62-9.1H310c.39-2.07.73-3.9 1.07-5.72l3.47-.33c.71-4.37 1.57-8.67 2.05-13a46 46 0 00.08-8.62c-.93-12-8.75-21-20-23.2-11.91-2.29-21.71 1.42-29.53 10.57-1.35 1.59-2.62 3.24-3.94 4.86z"
        transform="translate(0 -253.8)"
        fill="#cb0000"
      />
      <path
        d="M306.3 572.68c.79-.87 1.57-1.75 2.39-2.59q7.95-8.22 15.91-16.41l-.36-.84h-34.17a4.16 4.16 0 01-3.84-1.89c-3.35-4.69-6.77-9.33-10.14-14-.47-.66-.82-1.41-1.5-2.61H335.61a3.72 3.72 0 003.8-2.18c3-5.58 6.12-11.08 9.53-17.21h-3.71q-39.37 0-78.76.05c-2 0-3.09-.56-3.79-2.44-1.82-4.83-3.79-9.61-5.68-14.42a22.41 22.41 0 01-.61-2.36h3.2q46.91 0 93.8.05c2.26 0 3.28-.6 3.82-2.85 1.12-4.59 2.56-9.1 3.87-13.64a32.72 32.72 0 0021.23 13.15c6.55 1.18 13 .32 19.41-1 4.87-1 4.87-1 5.53-5.9 2.85-.34 5.17-1.24 5-4.76 1.75 4.26 4.3 7.81 8.57 9.92 8.17 4 20 1.89 26.29-4.8l1.72-.82v6h16.87c.28-1.92.55-3.74.81-5.57h7.39l-.83 5.88h19.68c.3-1.91.58-3.74.87-5.57l4.11-.24c.19-.7.42-1.34.53-2 1.4-8.62 2.64-17.27 4.22-25.86.9-4.88 2.33-9.66 3.52-14.49 2.51-1.52 4.46-4.27 8-3.64-.71 3.23-1.58 6.32-2.06 9.48-1.5 9.75-1.8 19.44 2.22 28.77 4.72 10.95 13.8 16.12 25 14.21 5.08-.86 9.32-3.4 13.42-7.35-.26 2.52-.45 4.46-.66 6.44h18.7c.29-2 .55-3.79.82-5.63l4.18-.19c4.89-30.39 9.76-60.69 14.67-91.21h-18a9.51 9.51 0 00-1.25.16c-.39 1.92-.75 3.73-1.12 5.54h-4.6c-.77 5.39-1.51 10.63-2.26 15.86-1-.72-2.07-1.47-3.12-2.16-6.27-4.12-12.91-4.72-19.9-2.13-5.58 2.06-9.65 6.13-13.65 10.28a10.9 10.9 0 00-2.26 1.52c-1.87 2.06-3.62 4.24-5.41 6.37 1.82-6.36 3.65-12.71 5.51-19.19a11.36 11.36 0 00-10.07 2.59c-2.75 2.36-5.12 5.18-7.62 7.76.47-3 .95-6.18 1.46-9.46h-17.82c-.38 2-.75 3.89-1.11 5.79h-4c-.89 4.85-1.73 9.41-2.57 14-.13-.75-.3-1.49-.39-2.25-1.35-10.63-7.37-17-18-18.69-9.46-1.55-18.72-.34-27.89 2.2-2.56.7-4.2 1.84-4.27 4.64-2.37.66-4.76 1.26-7.09 2a2.45 2.45 0 00-1.48 1.42c-.95 5.05-1.76 10.14-2.66 15.48l2.68-.73a62.51 62.51 0 0124.18-2.1c2.92.37 5.49 1.3 6.31 4.59-10.17.4-19.63 2.78-27.46 9.75a14.25 14.25 0 00-3 1c-6.25 3.69-10.52 8.8-11.31 16.29h.05l-.46.38c-2.88.95-5.7 2.14-8.65 2.8-10.62 2.39-19.31-2.92-22.14-13.39-1.61-5.93-1.12-11.91-.05-17.85 1-5.54 2.65-10.83 6.36-15.24l.41-.54a4.15 4.15 0 001.26-.27c4.47-2.66 9.32-3.84 14.36-2.74 4.8 1 9.44 2.76 14.27 4.23.33-1.92.75-4.38 1.17-6.85l3.8 1.67c1-6.89 2-13.52 3-20.09-.84-.34-1.3-.54-1.78-.7-9-3.08-18.05-5.18-27.63-3.27-6.79 1.35-12.56 4.78-18.17 8.59l-.51.62v-.06a5.1 5.1 0 00-1.72.53 98.4 98.4 0 00-8.12 6.83c-1.39 1.39-2.47 2.37-4.41 1.36v-.09c-.52-3.42-1-6.85-1.61-10.56H250.66c1.72-6.21 3.3-12 5-17.74.16-.52 1-1 1.63-1.17a6.86 6.86 0 012-.05h96.94c-1.89-4.86-3.93-9.3-5.34-13.94-1.36-4.48-3.89-5.6-8.48-5.55-25.16.27-50.31.13-75.47.13h-3.42c2.7-5 5.43-9.6 7.64-14.41 1.71-3.72 4.18-4.64 8.14-4.59 18.44.22 36.88.1 55.32.1h3.47c-2.69-3.9-4.94-7.33-7.38-10.63-2.16-2.93-4-6.75-7-8.24s-7-.46-10.53-.47h-24.89c1.92-2.21 3.39-4.11 5.07-5.79 3.66-3.67 7.44-7.2 11.13-10.83a14.72 14.72 0 001.52-2.19 180 180 0 01141.59-45.42 180.8 180.8 0 01149.5 117.31c8.32 22.85 12.34 46.47 10.69 70.7-4.47 65.73-35.37 115.52-92.21 148.91-22.64 13.3-47.4 20.56-73.62 22.45q-76.29 5.5-134.25-44.51c-.51-.44-.94-.96-1.41-1.44zM584 480.17a5.83 5.83 0 005.73 5.88 6 6 0 006-5.91 5.82 5.82 0 00-5.78-5.82 5.75 5.75 0 00-5.95 5.85z"
        transform="translate(0 -253.8)"
        fill="#fe9800"
      />
      <path
        className="prefix__cls-4"
        d="M102.6 469.63c-.9 5.25-1.8 10.51-2.72 15.9l-4 .21H80.19c3.48-22 6.89-43.54 10.31-65.12l-.78-.18q-3.25 9.39-6.52 18.79-5.88 16.2-11.77 32.4c-1.33 3.65-2.79 7.27-3.88 11-.67 2.28-1.71 3.5-4.17 3.12H53.16l-1.69-66.54h-.56l-4.07 25.5c-1.5 8.49-3 17-4.5 25.46-.89 5.09-1.73 10.17-2.61 15.39l-4 .23H21.18c4.82-28.87 9.55-57.33 14.3-85.79 1.13-5.9 1.13-5.9 7.31-5.9h21.76c.07 1.06.14 1.88.16 2.7l.64 40.2c0 .76.1 1.52.15 2.28v9.59a76 76 0 004.17-10.51q6.45-19.36 12.89-38.63c.78-1.85 1.07-4.5 2.46-5.34 1.56-.95 4.11-.3 6.23-.3H115c-.72 4.4-1.38 8.55-2.06 12.69q-4.44 26.7-8.86 53.39a12.12 12.12 0 000 2c-.49 2.49-.99 4.97-1.48 7.46z"
        transform="translate(0 -253.8)"
      />
      <path
        className="prefix__cls-5"
        d="M162.36 485.66h-16.51l.6-7.39a26.07 26.07 0 01-16.81 8.67c-9.49 1.17-17.93-3.64-20.22-12.33a36 36 0 01-.88-12.28c.36-3.76 2-7.4 3.11-11.09 3.63-4.54 7.85-8.32 13.4-10.41a51 51 0 0118.39-3h2.52l4.42.46c2.33-6.8.05-10.53-6.68-11.25-1.18-.13-2.38-.11-3.57-.14a65.28 65.28 0 00-22.24 3.24l1.87-12c-.15-4 2.26-5.34 5.74-6.21 8.71-2.16 17.46-3.32 26.41-1.85 11 1.8 17 8.17 18.33 19.25.07.59.12 1.18.18 1.77-.39 3.46-.79 6.93-1.19 10.39-.39 2.41-.84 4.81-1.18 7.23-1.14 8.21-2.24 16.43-3.35 24.65-.17.81-.34 1.63-.5 2.44-.61 3.32-1.2 6.58-1.84 9.85zm-22.1-16.42c6-3.94 7.37-10 7.91-16.75-5.66-.82-10.9-.55-15.82 1.94-2.08 1.06-4 2.45-4.35 5.11l-.43.5c-1.77 5.2.4 10.22 5 10.63 2.37.22 4.85-.73 7.28-1.15z"
        transform="translate(0 -253.8)"
      />
      <path
        d="M275.62 460.67c1.54 6 6.13 8.18 11.62 9.1 8 1.34 15.48-.76 22.93-3.25l2.15-.74c.05 0 .14.05.44.15-1.05 5.77-2 11.61-3.29 17.37-.18.8-2 1.25-3 1.86a69.64 69.64 0 01-24.75 1.44c-13-1.73-22-9.78-24.68-22.53a53.72 53.72 0 013.85-33.76c.64-1.43 1.24-2.88 1.86-4.32l.53-.81c1.32-1.62 2.59-3.27 3.94-4.86 7.82-9.15 17.62-12.86 29.53-10.57C308 412 315.79 421 316.72 433a46 46 0 01-.08 8.62c-.48 4.35-1.34 8.65-2.05 13l-3.47.33c-5.33-.05-10.66-.13-16-.15h-20zm3.88-27.62l-.46.47c-.7 1.89-1.4 3.78-2.17 5.88h21.41c1.17-6.57-1-11.29-5.72-12.63-4.13-1.17-10.74.08-13.12 6.3z"
        transform="translate(0 -253.8)"
        fill="#fcfcfc"
      />
      <path
        className="prefix__cls-5"
        d="M194.73 433.56c.74 1.41 1.17 3.2 2.3 4.15a22.91 22.91 0 005.73 3.15c7.5 3.2 13 8.05 14.52 16.51.38 5.8.2 11.54-2.16 17l-6.52 7.5c-3.94 1.43-7.79 3.62-11.84 4.1-6.17.72-12.48.44-18.73.22a110.71 110.71 0 01-11.26-1.49c.53-3.8 1-7.05 1.44-10.3.39-2.24.78-4.47 1.2-6.84 1.4.39 2.61.75 3.84 1 6.63 1.59 13.29 2.67 20.1 1.05a14.36 14.36 0 003.3-1.73 5.3 5.3 0 00-.81-8.52c-3.57-2.39-7.5-4.24-11.2-6.43-6.82-4-10.65-10-10.23-18 .23-4.23 1.52-8.41 2.32-12.61 4.61-8.62 12.53-12 21.61-12.47 7-.36 14.18.57 21.27 1a3.67 3.67 0 011 .46c-.79 5.53-1.57 11-2.36 16.58h-4.13c-5.09 0-10.21-.3-15.26.15-3.1.28-4.11 2.23-4.13 5.52z"
        transform="translate(0 -253.8)"
      />
      <path
        className="prefix__cls-4"
        d="M252 471c-.57 3.57-1.3 7.12-1.66 10.71-.23 2.36-1.15 3.66-3.55 3.88a6.35 6.35 0 00-1.4.5c-3.87.35-7.75 1-11.62 1-6.64 0-11.47-4-13-10.42a20.7 20.7 0 01-.55-7.29c1.87-13.51 3.93-27 6-40.46 1.18-7.7 2.53-15.37 3.81-23.05a1.88 1.88 0 00.24-.44c1.29-5.4 1.29-5.4 7-5.4h13.29c-.62 3.78-1.2 7.38-1.83 11.23h9.52c-.81 6.1-1.6 11.94-2.41 18l-3.21.31c-1.93 0-3.85-.17-5.77-.06a2 2 0 00-1.42 1.21c-.35 1.62-.46 3.3-.66 5Q243 446 241.26 456.33c-.37 2.17-.8 4.33-1 6.51-.34 3.49 1.26 5.58 4.75 5.84a42.47 42.47 0 006.54-.45c.13.91.28 1.83.45 2.77zM363.18 410.63v.09l-7.66 21.83c-3.64-1-6.81.53-8.82 4.36-.82 1.55-1.36 3.24-2 4.86-1.47 6.32-3.14 12.61-4.36 19-1.42 7.4-2.54 14.86-3.59 22.32-.29 2.09-.87 3.13-3.1 2.75a5.54 5.54 0 00-1.5.15h-15.48c.06-1.05 0-1.56.12-2.06q3.42-21.21 6.85-42.41c1.3-8.12 2.52-16.24 3.78-24.36l1.16-5.81h17.78c-.44 3.05-.87 6-1.42 9.79 5.06-6.26 9.54-12.28 18.24-10.51z"
        transform="translate(0 -253.8)"
      />
      <path
        className="prefix__cls-7"
        d="M344.7 441.77c.67-1.62 1.21-3.31 2-4.86 2-3.83 5.18-5.37 8.82-4.36l7.66-21.83c1.94 1 3 0 4.41-1.36a98.4 98.4 0 018.12-6.83 5.1 5.1 0 011.72-.53c-2.53 3-5.44 5.85-7.52 9.17-10.28 16.42-12.37 34.25-7.58 52.73 3.1 12 11.09 19.75 23.44 22.51 7.2 1.6 14.34.71 21.45-.71-.66 4.92-.66 4.92-5.53 5.9-6.43 1.29-12.86 2.15-19.41 1a32.72 32.72 0 01-21.23-13.15c-6.91-10.77-7.92-22.68-6.74-35 .5-5.23-1.39-6.62-6.62-4.51a20.55 20.55 0 00-2.99 1.83z"
        transform="translate(0 -253.8)"
      />
      <path
        className="prefix__cls-8"
        d="M252 471c-.14-.91-.29-1.83-.43-2.74-1.64-11.37-.44-22.39 4.69-32.73 1.7-3.41 4.32-6.35 6.51-9.51-.62 1.44-1.22 2.89-1.86 4.32a53.72 53.72 0 00-3.91 33.73c2.68 12.75 11.7 20.8 24.68 22.53a69.64 69.64 0 0024.75-1.44c.14 3.82-2 5.37-5.52 6-9.24 1.79-18.48 2.67-27.74.47-10.19-2.42-17.13-8.54-20.4-18.6-.2-.67-.52-1.36-.77-2.03z"
        transform="translate(0 -253.8)"
      />
      <path
        d="M35.48 400c-4.75 28.47-9.49 56.93-14.3 85.76h14.5l-1 5.7h-19c.63-4 1.2-7.83 1.85-11.64 4.36-25.86 8.76-51.71 13-77.58.31-1.87.9-2.53 2.7-2.28a19.41 19.41 0 002.25.04z"
        transform="translate(0 -253.8)"
        fill="#070366"
      />
      <path
        className="prefix__cls-10"
        d="M230.05 405.84c-1.28 7.68-2.63 15.35-3.81 23.05-2.09 13.47-4.15 26.95-6 40.46a20.7 20.7 0 00.55 7.29c1.5 6.44 6.33 10.4 13 10.42 3.87 0 7.75-.65 11.62-1-.33 4.49-.28 4.78-4.73 5.52a56.66 56.66 0 01-13.53 1.06c-6.81-.52-11.24-5.6-11.85-12.46-.17-1.93-.09-3.88-.13-5.82 2.36-5.45 2.54-11.19 2.16-17q1.51-8.72 3-17.44c1.77-10.25 3.51-20.49 5.31-30.73.61-3.49.69-3.48 4.41-3.35z"
        transform="translate(0 -253.8)"
      />
      <path
        className="prefix__cls-8"
        d="M111.65 451.24c-1.09 3.69-2.75 7.33-3.11 11.09a36 36 0 00.88 12.28c2.29 8.69 10.73 13.5 20.22 12.33a26.07 26.07 0 0016.81-8.67l-.6 7.39h12.75c-.69 5.66-.69 5.66-6.35 5.66H140.9v-6.55l-2.16 1.9c-6 5.37-13.13 7.11-20.86 5.82-9.09-1.52-14.29-8.52-14.77-19-.06-1.3-.34-2.59-.51-3.89.49-2.49 1-5 1.49-7.46 1.67-2.85 3.27-5.75 5-8.53a14.33 14.33 0 012.56-2.37z"
        transform="translate(0 -253.8)"
      />
      <path
        className="prefix__cls-11"
        d="M327.42 417.14c-1.26 8.12-2.48 16.24-3.78 24.36q-3.39 21.21-6.85 42.41c-.08.5-.06 1-.12 2.06h15.48c-.61 5.69-.61 5.69-6.33 5.69h-14.36c4-25 8-49.62 12-74.52z"
        transform="translate(0 -253.8)"
      />
      <path
        d="M46.84 444.67l4.07-25.5h.56l1.69 66.54h10.22c-1.75 5.85-1.75 5.85-7.75 5.85h-7.47z"
        transform="translate(0 -253.8)"
        fill="#080467"
      />
      <path
        className="prefix__cls-13"
        d="M83.2 439.23q3.26-9.41 6.52-18.79l.78.18c-3.42 21.58-6.83 43.16-10.31 65.12h15.66c-.34 1.9-.69 3.8-1 5.72H75.21c.71-4.59 1.37-9 2.07-13.37q2.89-18.3 5.8-36.58a21.62 21.62 0 00.12-2.28z"
        transform="translate(0 -253.8)"
      />
      <path
        className="prefix__cls-8"
        d="M176.73 422.37c-.8 4.2-2.09 8.38-2.32 12.61-.42 8 3.41 13.94 10.23 18 3.7 2.19 7.63 4 11.2 6.43a5.3 5.3 0 01.81 8.52 14.36 14.36 0 01-3.3 1.73 6 6 0 00-3.34-5.06c-3.3-1.89-6.68-3.65-10-5.54-6.78-3.86-10.53-9.61-10.79-17.5.4-3.46.8-6.93 1.19-10.39 1.39-2.39 2.71-4.82 4.21-7.14.46-.73 1.38-1.12 2.11-1.66z"
        transform="translate(0 -253.8)"
      />
      <path
        className="prefix__cls-10"
        d="M168.21 474.39c-.46 3.25-.91 6.5-1.44 10.3a110.71 110.71 0 0011.23 1.49c6.25.22 12.56.5 18.73-.22 4.05-.48 7.9-2.67 11.84-4.1-1.11 3.28-3.84 5-6.56 6.7a27.12 27.12 0 01-14.83 3.84c-7.52-.15-15-.86-22.54-1.41a13.47 13.47 0 01-2.87-.88c.2-1.62.38-3 .56-4.45.61-3.27 1.23-6.53 1.84-9.8.16-.81.33-1.63.5-2.44z"
        transform="translate(0 -253.8)"
      />
      <path
        className="prefix__cls-8"
        d="M119.76 418.19l-1.87 12a65.28 65.28 0 0122.24-3.24c1.19 0 2.39 0 3.57.14 6.73.72 9 4.45 6.68 11.25l-4.42-.46c-.69-3.52-3.4-4.39-6.4-4.77a62.14 62.14 0 00-23.69 2c-.74.2-1.47.41-2.22.58-.14 0-.32-.06-.75-.15.84-5.05 1.47-10.17 2.69-15.14.25-1.02 2.72-1.49 4.17-2.21z"
        transform="translate(0 -253.8)"
      />
      <path
        d="M275.62 460.67l-.51-5.88h20c5.34 0 10.67.1 16 .15l-1.07 5.72z"
        transform="translate(0 -253.8)"
        fill="#010166"
      />
      <path
        className="prefix__cls-13"
        d="M82.56 399.73q-6.44 19.32-12.89 38.62a76 76 0 01-4.17 10.51v-9.59l12-36c1.26-3.68 1.25-3.69 5.06-3.54z"
        transform="translate(0 -253.8)"
      />
      <path
        className="prefix__cls-10"
        d="M194.73 433.56c0-3.29 1-5.24 4.18-5.52 5.05-.45 10.17-.14 15.26-.15l-.89 5.67z"
        transform="translate(0 -253.8)"
      />
      <path
        className="prefix__cls-8"
        d="M244.79 435.64c.2-1.66.31-3.34.66-5a2 2 0 011.42-1.21c1.92-.11 3.84 0 5.77.06-.21 2-.42 4-.65 6.11zM263.24 425.21l-.53.81z"
        transform="translate(0 -253.8)"
      />
      <path
        className="prefix__cls-15"
        d="M569.9 400c.37-1.81.73-3.62 1.12-5.54a9.51 9.51 0 011.25-.16h18c-4.91 30.52-9.78 60.82-14.67 91.21l-4.18.19h-14.55c.25-2.28.46-4.17.73-6.6l-1.3 1.1c-13.77 11.88-31.45 7.71-37.57-9.35-5.92-16.53-2.64-32.18 6.47-46.84.43-.69.78-1.43 1.17-2.15 4-4.15 8.07-8.22 13.65-10.28 7-2.59 13.63-2 19.9 2.13 1.05.69 2.08 1.44 3.12 2.16 1.24 1.12 2.48 2.23 3.93 3.55L569.9 400zM554 465.17l-.05.05a26.92 26.92 0 003.5-3.93 32.87 32.87 0 003.54-25.67c-1-3.79-3.37-6.43-7.47-7.05a11.85 11.85 0 00-12.32 6.56l-.54.82c-4.66 7.77-5.27 16.19-3.18 24.71 1.87 7.64 9.63 9.83 16 5zM426.45 447.44c7.83-7 17.29-9.35 27.46-9.75l8.5.6c2.37-6.72.07-10.48-6.66-11.23-1.09-.12-2.2-.11-3.3-.14a65.06 65.06 0 00-22.53 3.25c.71-4.54 1.38-8.86 2.05-13.17.07-2.8 1.71-3.94 4.27-4.64 9.17-2.54 18.43-3.75 27.89-2.2 10.63 1.74 16.65 8.06 18 18.69.09.76.26 1.5.4 2.25-1 7.35-2 14.71-3.09 22.07-1.44 10.13-2.88 20.26-4.39 30.38a7.38 7.38 0 01-1.17 2.11h-16c.19-2.58.35-4.69.47-6.44l-9.56 6-1.72.82c-1.75.27-3.5.58-5.26.82-9.39 1.31-17.8-3.36-20.3-11.85-2.71-9.23-1.75-18.09 4.15-26.07a9.84 9.84 0 00.79-1.5zM440.69 458l-.44.45a8.93 8.93 0 00-.08 9.33c1.54 2.6 4.07 3.34 7 3 2-.64 4.28-.84 5.85-2 5.3-4 6.77-9.82 7.17-16.91-4.34.41-8.39.51-12.31 1.25-3 .55-5.86 1.78-7.21 4.95zM407.25 485.7c-7.11 1.42-14.25 2.31-21.45.71-12.35-2.76-20.34-10.53-23.44-22.51-4.79-18.48-2.7-36.31 7.58-52.73 2.08-3.32 5-6.13 7.52-9.17v.06l.51-.62c5.61-3.81 11.38-7.24 18.17-8.59 9.58-1.91 18.66.19 27.63 3.27.48.16.94.36 1.78.7-1 6.57-2 13.2-3 20.09l-3.8-1.67c-3.5-1.13-6.92-2.67-10.5-3.32-8-1.43-16.74 2.58-20.56 8.95l-.41.54c-3.71 4.41-5.36 9.7-6.36 15.24-1.07 5.94-1.56 11.92.05 17.85 2.83 10.47 11.52 15.78 22.14 13.39 2.95-.66 5.77-1.85 8.65-2.8l.46-.38h-.05l2.72-.67c-.89 5.74-1.75 11.32-2.61 16.89.14 3.53-2.18 4.43-5.03 4.77z"
        transform="translate(0 -253.8)"
      />
      <path
        d="M506 443.38c-1.19 4.83-2.62 9.61-3.52 14.49-1.58 8.59-2.82 17.24-4.22 25.86-.11.66-.34 1.3-.53 2l-4.11.24h-15.33c.09-1.22.09-2 .21-2.7 1.94-12 3.91-24 5.84-36.07 1.6-10 3.15-20.05 4.73-30.07.36-1.9.73-3.81 1.11-5.79H508c-.51 3.28-1 6.42-1.46 9.46 2.5-2.58 4.87-5.4 7.62-7.76a11.36 11.36 0 0110.05-2.52c-1.86 6.48-3.69 12.83-5.51 19.19-.3 1-.59 1.91-.88 2.84-6.72-.38-11.82 4.29-11.82 10.83z"
        transform="translate(0 -253.8)"
        fill="#fdfdfc"
      />
      <path
        className="prefix__cls-17"
        d="M506 443.38c.06-6.54 5.12-11.21 11.84-10.83.29-.93.58-1.89.88-2.84 1.79-2.13 3.54-4.31 5.41-6.37a10.9 10.9 0 012.26-1.52c-.39.72-.74 1.46-1.17 2.15-9.11 14.66-12.39 30.31-6.47 46.84 6.12 17.06 23.8 21.23 37.57 9.35l1.3-1.1c-.27 2.43-.48 4.32-.73 6.6h14.51c-.27 1.84-.53 3.67-.82 5.63h-18.7c.21-2 .4-3.92.66-6.44-4.1 3.95-8.34 6.49-13.42 7.35-11.21 1.91-20.29-3.26-25-14.21-4-9.33-3.72-19-2.22-28.77.48-3.16 1.35-6.25 2.06-9.48-3.52-.63-5.47 2.12-7.96 3.64z"
        transform="translate(0 -253.8)"
      />
      <path
        className="prefix__cls-7"
        d="M412.23 480.94c.86-5.57 1.72-11.15 2.61-16.89l-2.72.67c.79-7.49 5.06-12.6 11.31-16.29a14.25 14.25 0 013-1 9.84 9.84 0 01-.77 1.52c-5.9 8-6.86 16.84-4.15 26.07 2.5 8.49 10.91 13.16 20.3 11.85 1.76-.24 3.51-.55 5.26-.82-6.28 6.69-18.12 8.84-26.29 4.8-4.25-2.1-6.78-5.65-8.55-9.91z"
        transform="translate(0 -253.8)"
      />
      <path
        className="prefix__cls-18"
        d="M489.07 417.13c-1.58 10-3.13 20.05-4.73 30.07-1.93 12-3.9 24-5.84 36.07-.12.73-.12 1.48-.21 2.7h15.31c-.29 1.83-.57 3.66-.87 5.57h-19.68l.83-5.88a7.38 7.38 0 001.17-2.11c1.51-10.12 2.95-20.25 4.39-30.38 1.05-7.36 2.06-14.72 3.09-22.07.83-4.56 1.67-9.12 2.56-14z"
        transform="translate(0 -253.8)"
      />
      <path
        className="prefix__cls-7"
        d="M432 417c-.67 4.31-1.34 8.63-2.05 13.17a65.06 65.06 0 0122.53-3.25c1.1 0 2.21 0 3.3.14 6.73.75 9 4.51 6.66 11.23l-8.5-.6c-.82-3.29-3.39-4.22-6.31-4.59a62.51 62.51 0 00-24.18 2.1l-2.68.73c.9-5.34 1.71-10.43 2.66-15.48a2.45 2.45 0 011.48-1.42c2.3-.77 4.69-1.37 7.09-2.03z"
        transform="translate(0 -253.8)"
      />
      <path
        className="prefix__cls-17"
        d="M387.61 420.87c3.82-6.37 12.57-10.38 20.56-8.95 3.58.65 7 2.19 10.5 3.32-.42 2.47-.84 4.93-1.17 6.85-4.83-1.47-9.47-3.19-14.27-4.23-5-1.1-9.89.08-14.36 2.74a4.15 4.15 0 01-1.26.27z"
        transform="translate(0 -253.8)"
      />
      <path
        className="prefix__cls-8"
        d="M448.81 485.24l9.56-6c-.12 1.75-.28 3.86-.47 6.44h8.59c-.26 1.83-.53 3.65-.81 5.57h-16.87z"
        transform="translate(0 -253.8)"
      />
      <path
        className="prefix__cls-18"
        d="M569.9 400q-1.46 9.7-2.93 19.41c-1.45-1.32-2.69-2.43-3.93-3.55.75-5.23 1.49-10.47 2.26-15.86z"
        transform="translate(0 -253.8)"
      />
      <path
        className="prefix__cls-19"
        d="M584 480.17a5.75 5.75 0 016-5.85 5.82 5.82 0 015.78 5.82 6 6 0 01-6 5.91 5.83 5.83 0 01-5.78-5.88zm2.78 3.66c2.78 1.65 5.13 1.44 6.79-.59a4.81 4.81 0 00-.08-6.28c-1.74-2-4.21-2.11-6.79-.35-2.35 2.6-2.33 4.59.07 7.22z"
        transform="translate(0 -253.8)"
      />
      <path className="prefix__cls-7" d="M412.17 464.68l-.46.38z" transform="translate(0 -253.8)" />
      <path
        className="prefix__cls-17"
        d="M387.23 421.38l.41-.54z"
        transform="translate(0 -253.8)"
      />
      <path className="prefix__cls-7" d="M377.94 401.44l-.51.62z" transform="translate(0 -253.8)" />
      <path
        className="prefix__cls-20"
        d="M168.21 474.39l-3.51-1c1.11-8.22 2.21-16.44 3.35-24.65.34-2.42.79-4.82 1.18-7.23.26 7.89 4 13.64 10.79 17.5 3.31 1.89 6.69 3.65 10 5.54a6 6 0 013.34 5.06c-6.81 1.62-13.47.54-20.1-1.05-1.23-.29-2.44-.65-3.84-1-.42 2.36-.82 4.59-1.21 6.83zM139.83 469.51c-2.43.42-4.91 1.37-7.28 1.15-4.59-.41-6.76-5.43-5-10.63l.43-.5c4.48-1.1 9-2.11 14.27-1.2-.69 3.73-1.35 7.31-2 10.9z"
        transform="translate(0 -253.8)"
      />
      <path
        className="prefix__cls-11"
        d="M140.21 469.26c.66-3.59 1.32-7.17 2-10.9-5.3-.91-9.79.1-14.27 1.2.32-2.66 2.27-4.05 4.35-5.11 4.92-2.49 10.16-2.76 15.82-1.94-.53 6.73-1.86 12.81-7.9 16.75zM128 459.53l-.43.5zM139.83 469.51l.43-.27z"
        transform="translate(0 -253.8)"
      />
      <path
        className="prefix__cls-17"
        d="M279.44 433.07c2.38-6.22 9-7.47 13.12-6.3 4.73 1.34 6.89 6.06 5.72 12.63h-5c-1.21-4.9-3.77-7.19-8.41-7.18a34.33 34.33 0 00-5.43.85z"
        transform="translate(0 -253.8)"
      />
      <path
        d="M279.44 433.07a34.33 34.33 0 015.47-.85c4.64 0 7.2 2.28 8.41 7.18h-16.45c.77-2.1 1.47-4 2.17-5.88l.46-.47z"
        transform="translate(0 -253.8)"
        fill="#c9090b"
      />
      <path
        className="prefix__cls-17"
        d="M279.5 433.05l-.46.47c.15-.16.3-.32.46-.47z"
        transform="translate(0 -253.8)"
      />
      <path
        className="prefix__cls-22"
        d="M553.45 465.59c-6.37 4.87-14.13 2.68-16-5-2.09-8.52-1.48-16.94 3.18-24.71l.54-.82a4.69 4.69 0 001.3 0c7.08-2.34 12.26.31 13.7 7.58a39.37 39.37 0 01.46 11.57c-.38 3.71-1.76 7.32-2.71 11l.05-.05z"
        transform="translate(0 -253.8)"
      />
      <path
        className="prefix__cls-17"
        d="M553.9 465.22c1-3.65 2.33-7.26 2.71-11a39.37 39.37 0 00-.46-11.57c-1.44-7.27-6.62-9.92-13.7-7.58a4.69 4.69 0 01-1.3 0 11.85 11.85 0 0112.32-6.56c4.1.62 6.5 3.26 7.47 7.05a32.87 32.87 0 01-3.54 25.67 26.92 26.92 0 01-3.5 3.99zM553.45 465.59l.5-.42zM541.17 435.1l-.54.82zM440.65 458.06c1.35-3.17 4.25-4.4 7.21-4.95 3.92-.74 8-.84 12.31-1.25-.4 7.09-1.87 12.93-7.17 16.91-1.57 1.17-3.88 1.37-5.85 2 1.74-4 3-8.11 2.47-12.72z"
        transform="translate(0 -253.8)"
      />
      <path
        className="prefix__cls-22"
        d="M440.65 458.06h9c.51 4.61-.73 8.71-2.47 12.72-2.91.37-5.44-.37-7-3a8.93 8.93 0 01.08-9.33l.44-.45z"
        transform="translate(0 -253.8)"
      />
      <path className="prefix__cls-17" d="M440.69 458l-.44.45z" transform="translate(0 -253.8)" />
      <path
        className="prefix__cls-23"
        d="M586.69 476.61c2.58-1.76 5-1.64 6.79.35a4.81 4.81 0 01.08 6.28c-1.66 2-4 2.24-6.79.59l.52-.5 2.33-3.22 1.75 3.75.93-.78-1.21-2c.35-1.16 1.08-2.31.76-2.86s-1.62-.94-2.54-1.18a7.27 7.27 0 00-2 .07z"
        transform="translate(0 -253.8)"
      />
      <path
        className="prefix__cls-23"
        d="M586.77 483.83c-2.4-2.63-2.42-4.62-.08-7.22l.6.51v6.21z"
        transform="translate(0 -253.8)"
      />
      <path
        className="prefix__cls-19"
        d="M587.29 483.33v-6.21a7.27 7.27 0 012-.07c.92.24 2.15.51 2.54 1.18s-.41 1.7-.76 2.86l1.21 2-.93.78-1.75-3.75z"
        transform="translate(0 -253.8)"
      />
    </svg>
  );
};

export const VisaCard = (props) => {
  return (
    <svg
      id="prefix__Layer_1"
      data-name="Layer 1"
      viewBox="0 0 610.37 391"
      width="1em"
      height="1em"
      {...props}
    >
      <defs>
        <style>{'.prefix__cls-1{fill:#fefefe}.prefix__cls-6{fill:#345a82}'}</style>
      </defs>
      <title>{'visacard'}</title>
      <path
        className="prefix__cls-1"
        d="M2.62 228l-1 1zM612 229l-1-1zM1.6 618l1 1z"
        transform="translate(-1.6 -228)"
      />
      <path
        d="M307.66 239.52h250.43a68.86 68.86 0 0112.59 1c20.22 3.84 30.75 17.4 30.76 39.47v289.19c0 26.1-14.52 40.82-40.66 41.28H55.88C38.3 610.48 24.11 604 16.83 587a45.05 45.05 0 01-3.55-17.14Q13 425 13.16 280.17c0-24.2 17.07-40.62 42.06-40.64q126.23-.04 252.44-.01zm-.66 6.75H55.12c-23.3 0-35.23 12-35.23 35.27v286.59a36.72 36.72 0 00.47 7C24 593.51 37 603.77 56.45 603.77H558.7c1.52 0 3 0 4.56-.08 14.34-.92 24.63-7.76 28.2-19.87a64.59 64.59 0 002.29-17.91q.19-140.77.08-281.53c0-2.7 0-5.4-.17-8.1-.68-14.38-8.83-25-22.27-28.45a55.21 55.21 0 00-13.51-1.5q-125.44-.13-250.88-.06z"
        transform="translate(-1.6 -228)"
        fill="#3f6389"
      />
      <path
        d="M307 246.27q125.45 0 250.88.06a55.21 55.21 0 0113.51 1.5c13.44 3.42 21.59 14.07 22.27 28.45.13 2.7.17 5.4.17 8.1q0 140.76-.08 281.53a64.59 64.59 0 01-2.29 17.91c-3.57 12.11-13.86 18.95-28.2 19.87-1.51.09-3 .08-4.56.08H56.45c-19.45 0-32.45-10.26-36.08-28.59a36.72 36.72 0 01-.47-7V281.59c0-23.25 11.93-35.26 35.23-35.27q125.93-.08 251.87-.05zM577.5 348.9c0-20.84.06-41.25 0-61.66-.07-17-7.84-24.64-25-24.64H59.9c-17.53 0-22.6 4.87-22.78 22.52-.19 20.42 0 40.84 0 61.26a21.14 21.14 0 00.31 2.51zM37.24 500.53c0 22.31-.46 44.07.17 65.8.38 13.22 7.8 19.94 20.72 21.07 1.51.13 3 .05 4.56.05H554.78c14.23-.75 22.19-8 22.49-22.12.46-21.25.1-42.52.07-63.78 0-.27-.34-.55-.63-1zM110.53 367c7.33 3.52 13.36 6.32 19.29 9.31 6.61 3.33 10.56 8.24 11 16.17 1 20.19 2.56 40.36 3.93 60.54.6 8.83 1.3 17.66 2 26.76 9.85 0 19.13.15 28.39-.16 1.53-.05 3.45-1.82 4.42-3.31q26.66-40.86 53.11-81.86c5.82-9 11.62-18 17.64-27.33h-37.22c4.19 6.4 3 12-.43 17.84-10.67 18.15-21 36.49-31.52 54.75-1.46 2.54-3 5.05-4.44 7.58l-1-.32-2.4-80zm323.8-.15c-1.26 3.32-2 6.13-3.31 8.6q-24.7 45.27-49.57 90.44c-2.53 4.61-5.3 9.09-7.95 13.62h29.72c0-2.59-.68-5.15.12-7.13 3-7.47 6.4-14.8 9.91-22.06.48-1 2.39-1.82 3.66-1.84 8.61-.16 17.23 0 25.84-.12 2.43 0 3.86.62 3.91 3.33.14 9.25 4.16 18.43.07 27.69h37.85c-1.88-3.72-4.7-7-5.15-10.57-3.39-26.76-6.36-53.58-9.35-80.39-.79-7.12-1.18-14.27-1.76-21.57zM381.8 392a4.72 4.72 0 00.52-1.16c.9-4.46 1.23-9.12 2.76-13.34 2-5.66-.43-8.06-5.24-9.6-.64-.2-1.21-.6-1.83-.85-22.26-8.63-43.69-8.94-63.82 5.91-6.72 4.95-11.78 10.86-11.89 19.5-.14 12.22 3.55 22.78 14.2 30.16 8.57 5.95 17.32 11.8 25.12 18.67 7 6.12 5.74 14.33-2 19.55a22.87 22.87 0 01-8.32 3.34c-9.17 1.76-17.16-2.33-25.14-5.87-6.22-2.77-12.25-6-18.8-9.22v5.17c0 17.32-.12 17.52 16.15 23.56 22.74 8.44 44.18 7.72 63.26-9.51 13.33-12 15-28.89 2.73-42-5.69-6.05-13.18-10.4-19.71-15.69-4.18-3.38-8.6-6.66-12-10.74-6.31-7.53-2.2-17.58 7.59-18.82 3.91-.49 8.29-.5 11.94.76 8.2 2.83 16.11 6.61 24.48 10.18zm-116.51 87.53c0-5.79-.63-11.19.18-16.36s3.07-10.29 4.66-15.44c2.14-6.92 3.91-14 6.43-20.75 7.39-19.85 9.68-41.56 21.67-59.84H258c2.43 7 1.28 13.28-.91 19.66-10.56 30.76-17.84 62.61-30.71 92.73z"
        transform="translate(-1.6 -228)"
        fill="#fefefd"
      />
      <path
        d="M577.5 348.9H37.41a21.14 21.14 0 01-.31-2.51c0-20.42-.16-40.84 0-61.26.18-17.65 5.25-22.52 22.78-22.52h492.6c17.13 0 24.9 7.63 25 24.64.08 20.4.02 40.81.02 61.65z"
        transform="translate(-1.6 -228)"
        fill="#335982"
      />
      <path
        d="M37.24 500.53h539.47c.29.46.63.74.63 1 0 21.26.39 42.53-.07 63.78-.3 14.1-8.26 21.37-22.49 22.12-1.18.06-2.36 0-3.55 0H62.69c-1.52 0-3 .08-4.56-.05-12.92-1.13-20.34-7.85-20.72-21.07-.63-21.71-.17-43.47-.17-65.78z"
        transform="translate(-1.6 -228)"
        fill="#dea43b"
      />
      <path
        className="prefix__cls-6"
        d="M110.53 367h62.78l2.4 80 1 .32c1.48-2.53 3-5 4.44-7.58 10.48-18.3 20.85-36.64 31.51-54.74 3.45-5.87 4.62-11.44.43-17.84h37.16c-6 9.33-11.82 18.34-17.64 27.33q-26.51 41-53.11 81.86c-1 1.49-2.89 3.26-4.42 3.31-9.26.31-18.54.16-28.39.16-.67-9.1-1.37-17.93-2-26.76-1.37-20.18-2.9-40.35-3.93-60.54-.41-7.93-4.36-12.84-11-16.17-5.87-3.04-11.9-5.84-19.23-9.35z"
        transform="translate(-1.6 -228)"
      />
      <path
        d="M434.33 366.84h34c.58 7.3 1 14.45 1.76 21.57 3 26.81 6 53.63 9.35 80.39.45 3.58 3.27 6.85 5.15 10.57h-37.86c4.09-9.26.07-18.44-.07-27.69-.05-2.71-1.48-3.35-3.91-3.33-8.61.08-17.23 0-25.84.12-1.27 0-3.18.85-3.66 1.84-3.51 7.26-6.9 14.59-9.91 22.06-.8 2-.12 4.54-.12 7.13H373.5c2.65-4.53 5.42-9 7.95-13.62Q406.3 420.7 431 375.44c1.36-2.44 2.07-5.28 3.33-8.6zm7.19 30.49l-1.34-.3-18.13 34.91h22.53c-1.04-11.73-2.05-23.17-3.06-34.61z"
        transform="translate(-1.6 -228)"
        fill="#345a83"
      />
      <path
        className="prefix__cls-6"
        d="M381.8 392c-8.37-3.53-16.28-7.31-24.5-10.15-3.65-1.26-8-1.25-11.94-.76-9.79 1.24-13.9 11.29-7.59 18.82 3.41 4.08 7.83 7.36 12 10.74 6.53 5.29 14 9.64 19.71 15.69 12.31 13.08 10.6 29.94-2.73 42-19.08 17.23-40.52 18-63.26 9.51-16.27-6-16.19-6.24-16.15-23.56v-5.17c6.55 3.24 12.58 6.45 18.8 9.22 8 3.54 16 7.63 25.14 5.87a22.87 22.87 0 008.32-3.34c7.75-5.22 9-13.43 2-19.55-7.8-6.87-16.55-12.72-25.12-18.67-10.65-7.38-14.34-17.94-14.2-30.16.11-8.64 5.17-14.55 11.89-19.5 20.13-14.85 41.56-14.54 63.82-5.91.62.25 1.19.65 1.83.85 4.81 1.54 7.28 3.94 5.24 9.6-1.53 4.22-1.86 8.88-2.76 13.34a4.72 4.72 0 01-.5 1.13zM265.29 479.53h-38.9c12.87-30.12 20.15-62 30.71-92.73 2.19-6.38 3.34-12.69.91-19.66h40.22c-12 18.28-14.28 40-21.67 59.84-2.52 6.78-4.29 13.83-6.43 20.75-1.59 5.15-3.84 10.18-4.66 15.44s-.18 10.57-.18 16.36z"
        transform="translate(-1.6 -228)"
      />
      <path
        d="M441.52 397.33c1 11.44 2 22.88 3.06 34.61h-22.53L440.18 397z"
        transform="translate(-1.6 -228)"
        fill="#f4f6f8"
      />
    </svg>
  );
};

export const CoinMarketCapIcon = (props) => {
  return (
    <svg viewBox="0 0 76.52 77.67" width="1em" height="1em" {...props}>
      <path
        d="M66.54 46.41a4.09 4.09 0 01-4.17.28C60.83 45.82 60 43.78 60 41v-8.52c0-4.09-1.62-7-4.33-7.79-4.58-1.34-8 4.27-9.32 6.38l-8.1 13.11v-16c-.09-3.69-1.29-5.9-3.56-6.56-1.5-.44-3.75-.26-5.94 3.08L10.64 53.77A32 32 0 017 38.83C7 21.31 21 7.06 38.25 7.06s31.3 14.25 31.3 31.77v.18c.17 3.39-.93 6.09-3 7.4zm10-7.57v-.17C76.4 17.32 59.28 0 38.25 0S0 17.42 0 38.83s17.16 38.84 38.25 38.84a37.81 37.81 0 0026-10.36 3.56 3.56 0 00.18-5 3.43 3.43 0 00-4.86-.23A30.93 30.93 0 0115 60l16.3-26.2v12.09c0 5.81 2.25 7.69 4.14 8.24s4.78.17 7.81-4.75l9-14.57c.28-.47.55-.87.79-1.22V41c0 5.43 2.18 9.77 6 11.91a11 11 0 0011.21-.45c4.2-2.73 6.49-7.67 6.25-13.62z"
        fill="#fff"
      />
    </svg>
  );
};

export const ErrorIcon = (props) => {
  return (
    <svg
      id="prefix__Layer_1"
      data-name="Layer 1"
      viewBox="0 0 512 512"
      width="2em"
      height="1.75em"
      {...props}
    >
      <defs>
        <style>{'.prefix__cls-1{fill:#fff}'}</style>
      </defs>
      <path
        className="prefix__cls-1"
        d="M287.15 226c7.78.43 16.57 1.06 25.37 1.34 4.06.13 5.08 2.08 4.93 5.71-1.07 24.77-2 49.55-3.08 74.33-.6 13.8-1.25 27.6-2.12 41.38q-2.43 38.1-5.18 76.17c-.55 7.54-.81 7.78-8.75 8.37a211.78 211.78 0 01-24.41.76c-7.14-.3-8.33-1.68-8.59-8.11-.61-15.27-2-30.51-2.8-45.77q-2.2-42.58-4-85.19c-.86-20.45-1.3-40.91-2.07-61.36-.15-4 .81-6.39 5.28-6.53 8.11-.23 16.27-.67 25.42-1.1zM286.69 507.71c-7.42-.43-14.38-1-21.35-1.16-4.22-.11-6.28-2.36-6.44-6.07q-.72-16.65-.85-33.34a44.49 44.49 0 011.29-11.81c.52-1.89 3-4.55 4.61-4.62 14.4-.59 28.81-.82 43.22-.81 4.85 0 7.35 3 7.29 8.11-.17 13.43-.11 26.88-.21 40.31 0 4.95-1.81 8.1-7.61 8.15-6.79.05-13.57.81-19.95 1.24z"
        transform="translate(-31 -111)"
      />
    </svg>
  );
};

export const InfoIcon = (props) => {
  return (
    <svg
      id="prefix__Layer_1"
      data-name="Layer 1"
      viewBox="0 0 480 480"
      width="2.25em"
      height="2.25em"
      {...props}
    >
      <defs>
        <style>{'.prefix__cls-1{fill:#fff}'}</style>
      </defs>
      <path
        className="prefix__cls-1"
        d="M249.3 515.38v-14.1c6.13-.33 12.07-.49 18-1 7.64-.66 10.95-3.8 11-11.45q.25-46.5 0-93c0-6.26-3.32-10-10.11-11-7-1-14.2-1-21.68-1.48v-13.8l91.24-3.29v121c0 9.39 2.3 12 11.82 13 5.12.55 10.28.66 15.8 1v14.13zM302.28 342.92a32.87 32.87 0 01-33.37-33.08 33.38 33.38 0 0133.45-33.74 33.85 33.85 0 0133.36 33.57 33.36 33.36 0 01-33.44 33.25z"
        transform="translate(-66 -156)"
      />
    </svg>
  );
};

export const TradingIcon = (props) => {
  return (
    <svg id="prefix__Layer_1" x={0} y={0} viewBox="0 0 48 36" xmlSpace="preserve" {...props}>
      <style>
        {
          '.prefix__st0,.prefix__st1{fill:none;stroke-width:2}.prefix__st0{stroke-linejoin:round}.prefix__st1{stroke-miterlimit:10}'
        }
      </style>
      <g id="prefix__Layer_2_1_">
        <g id="prefix__icons">
          <path
            className="prefix__st0 svg-icon-color-stroke"
            d="M44 35H4c-1.7 0-3-1.3-3-3v-2h18l1 1h8l1-1h18v2c0 1.7-1.3 3-3 3zM4 30V3c0-1.1.9-2 2-2h36c1.1 0 2 .9 2 2v27"
          />
          <path
            className="prefix__st1 svg-icon-color-stroke"
            d="M14 25V13h4v12M22 25V7h4v18M30 25v-9h4v9"
          />
        </g>
      </g>
    </svg>
  );
};

export const CrownIcon = (props) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="1280.000000pt"
      height="740.000000pt"
      viewBox="0 0 1280.000000 740.000000"
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <metadata>Created by potrace 1.15, written by Peter Selinger 2001-2017</metadata>
      <g
        transform="translate(0.000000,740.000000) scale(0.100000,-0.100000)"
        fill="yellow"
        stroke="none"
      >
        <path
          d="M-1 7288 c0 -85 100 -1014 398 -3701 l398 -3587 5605 0 5605 0 398
		3588 c298 2686 398 3615 398 3700 l-1 112 -172 -1 -173 0 -1484 -1855 c-1023
		-1279 -1487 -1851 -1495 -1845 -6 5 -675 840 -1486 1855 l-1475 1845 -115 0
		-115 0 -1475 -1845 c-811 -1015 -1480 -1850 -1486 -1855 -8 -6 -472 566 -1495
		1845 l-1484 1855 -172 0 -173 1 -1 -112z"
        />
      </g>
    </svg>
  );
};

// *********************************************************************************************************************

export interface IIndicatorImageProps extends React.HTMLProps<any> {
  color: string;
  simplified: boolean;
}

const $IndicatorImageSvg = styled.svg<{ color: string }>`
  .svg-icon-color-fill {
    fill: ${(p) => p.color};
  }
  .svg-icon-color-stroke {
    stroke: ${(p) => p.color};
  }
`;

export const KYCLevel0IndicatorImage: React.FunctionComponent<IIndicatorImageProps> = ({
  simplified = false,
  ...passProps
}) => {
  return (
    <$IndicatorImageSvg
      xmlns="http://www.w3.org/2000/svg"
      width="67"
      height="67"
      viewBox="0 0 67 67"
      version="1.1"
      {...(passProps as any)}
    >
      {!simplified && (
        <path
          className="svg-icon-color-fill"
          strokeWidth="1.177"
          d="M33.463 0a33.598 33.598 0 00-6.914.748l.707 2.643a30.866 30.866 0 016.342-.658 30.866 30.866 0 016.343.658l.707-2.64a33.598 33.598 0 00-7.05-.75 33.598 33.598 0 00-.135 0zM23.279 1.625a33.598 33.598 0 00-12.21 7.05l1.933 1.934a30.866 30.866 0 0110.984-6.341zm20.639 0l-.707 2.643a30.866 30.866 0 0110.982 6.34l1.934-1.934a33.598 33.598 0 00-12.209-7.049zM8.674 11.066A33.598 33.598 0 001.625 23.28l2.643.707a30.866 30.866 0 016.341-10.984zm49.848.002l-1.934 1.934a30.866 30.866 0 016.342 10.984l2.64-.707a33.598 33.598 0 00-7.048-12.21zM.75 26.547a33.598 33.598 0 00-.75 7.05 33.598 33.598 0 00.75 7.052l2.643-.707a30.866 30.866 0 01-.66-6.344 30.866 30.866 0 01.66-6.344zm65.697 0l-2.64.707a30.866 30.866 0 01.658 6.344 30.866 30.866 0 01-.658 6.344l2.64.707a33.598 33.598 0 00.748-7.051 33.598 33.598 0 00-.748-7.051zM4.267 43.209l-2.642.707a33.598 33.598 0 007.05 12.211l1.934-1.934A30.866 30.866 0 014.268 43.21zm58.665 0a30.866 30.866 0 01-6.344 10.984l1.934 1.934a33.598 33.598 0 007.048-12.21zM13.004 56.588l-1.934 1.934a33.598 33.598 0 0012.21 7.048l.706-2.64a30.866 30.866 0 01-10.982-6.342zm41.191 0a30.866 30.866 0 01-10.984 6.342l.707 2.64a33.598 33.598 0 0012.21-7.048zm-26.94 7.217l-.706 2.64a33.598 33.598 0 007.049.75 33.598 33.598 0 007.05-.75l-.707-2.64a30.866 30.866 0 01-6.343.66 30.866 30.866 0 01-6.342-.66z"
        />
      )}

      <g
        className="svg-icon-color-fill"
        fill="#fff"
        fillOpacity="1"
        stroke="none"
        strokeWidth="0.304"
        fontFamily="Nunito"
        fontSize="9.878"
        fontStretch="normal"
        fontStyle="normal"
        fontWeight="bold"
        transform="matrix(3.77953 0 0 3.77953 -323.98 -246.618)"
        style={{
          lineHeight: '1.25',
          fontVariantLigatures: 'normal',
          fontVariantCaps: 'normal',
          fontVariantNumeric: 'normal',
          fontVariantEastAsian: 'normal',
        }}
        fontVariant="normal"
        letterSpacing="0"
        wordSpacing="0"
      >
        <path
          d="M94.718 77.716q-1.235 0-1.887-.908-.652-.92-.652-2.667 0-1.739.652-2.648.652-.918 1.887-.918 1.235 0 1.887.918.652.909.652 2.648 0 1.738-.652 2.657-.652.918-1.887.918zm0-.997q.672 0 .978-.613.306-.622.306-1.965 0-1.354-.306-1.956-.306-.613-.978-.613-.672 0-.978.613-.306.612-.306 1.956 0 1.343.306 1.965.306.613.978.613z"
          style={{
            fontVariantLigatures: 'normal',
            fontVariantCaps: 'normal',
            fontVariantNumeric: 'normal',
            fontVariantEastAsian: 'normal',
          }}
          strokeWidth="0.304"
          fontFamily="Nunito"
          fontSize="9.878"
          fontStretch="normal"
          fontStyle="normal"
          fontVariant="normal"
          fontWeight="bold"
        />
      </g>
    </$IndicatorImageSvg>
  );
};

export const KYCLevel1IndicatorImage: React.FunctionComponent<IIndicatorImageProps> = ({
  simplified = false,
  ...passProps
}) => {
  return (
    <$IndicatorImageSvg
      xmlns="http://www.w3.org/2000/svg"
      width="67"
      height="67"
      viewBox="0 0 67 67"
      version="1.1"
      {...(passProps as any)}
    >
      {!simplified && (
        <>
          <path
            fill="#fff"
            className="svg-icon-color-fill"
            strokeWidth="1.177"
            d="M33.463 0A33.598 33.598 0 000 33.598a33.598 33.598 0 0033.598 33.597 33.598 33.598 0 0033.597-33.597A33.598 33.598 0 0033.598 0a33.598 33.598 0 00-.135 0zm.135 2.732a30.866 30.866 0 0130.867 30.866 30.866 30.866 0 01-30.867 30.867A30.866 30.866 0 012.733 33.598 30.866 30.866 0 0133.598 2.732z"
          />
          <path
            fill="#fff"
            className="svg-icon-color-fill"
            stroke="none"
            strokeDasharray="none"
            strokeMiterlimit="4"
            strokeWidth="1.18"
            d="M36.488 7.723v2.75a23.307 23.307 0 0120.416 23.125 23.307 23.307 0 01-3.156 11.71l2.365 1.366a26.036 26.036 0 003.521-13.076A26.036 26.036 0 0036.488 7.723z"
          />
        </>
      )}

      <g
        className="svg-icon-color-fill"
        fill="#fff"
        fillOpacity="1"
        stroke="none"
        strokeWidth="0.304"
        fontFamily="Nunito"
        fontSize="9.878"
        fontStretch="normal"
        fontStyle="normal"
        fontWeight="bold"
        transform="matrix(3.77953 0 0 3.77953 -443.98 -246.619)"
        style={{
          lineHeight: '1.25',
          fontVariantLigatures: 'normal',
          fontVariantCaps: 'normal',
          fontVariantNumeric: 'normal',
          fontVariantEastAsian: 'normal',
        }}
        fontVariant="normal"
        letterSpacing="0"
        wordSpacing="0"
      >
        <path
          d="M128.453 76.6q.593 0 .593.504 0 .523-.593.523h-3.338q-.603 0-.603-.523 0-.504.603-.504h1.027v-4.504l-.948.583q-.139.079-.247.079-.208 0-.356-.178-.138-.178-.138-.395 0-.287.257-.445l1.53-.948q.297-.178.564-.178.276 0 .444.168.168.168.168.464V76.6z"
          style={{
            fontVariantLigatures: 'normal',
            fontVariantCaps: 'normal',
            fontVariantNumeric: 'normal',
            fontVariantEastAsian: 'normal',
          }}
          strokeWidth="0.304"
          fontFamily="Nunito"
          fontSize="9.878"
          fontStretch="normal"
          fontStyle="normal"
          fontVariant="normal"
          fontWeight="bold"
        />
      </g>
    </$IndicatorImageSvg>
  );
};

export const KYCLevel2IndicatorImage: React.FunctionComponent<IIndicatorImageProps> = ({
  simplified = false,
  ...passProps
}) => {
  return (
    <$IndicatorImageSvg
      xmlns="http://www.w3.org/2000/svg"
      width="67"
      height="67"
      viewBox="0 0 67 67"
      version="1.1"
      {...(passProps as any)}
    >
      {!simplified && (
        <>
          <path
            className="svg-icon-color-fill"
            fill="#fff"
            strokeWidth="1.177"
            d="M33.463 0A33.598 33.598 0 000 33.598a33.598 33.598 0 0033.598 33.597 33.598 33.598 0 0033.597-33.597A33.598 33.598 0 0033.598 0a33.598 33.598 0 00-.135 0zm.135 2.732a30.866 30.866 0 0130.867 30.866 30.866 30.866 0 01-30.867 30.867A30.866 30.866 0 012.733 33.598 30.866 30.866 0 0133.598 2.732z"
          />
          <path
            className="svg-icon-color-fill"
            fill="#fff"
            stroke="none"
            strokeDasharray="none"
            strokeMiterlimit="4"
            strokeWidth="1.18"
            d="M33.597 7.56v2.731a23.307 23.307 0 0123.307 23.307 23.307 23.307 0 01-23.307 23.306A23.307 23.307 0 0113.414 45.25l-2.366 1.365a26.036 26.036 0 0022.55 13.02 26.036 26.036 0 0026.036-26.037A26.036 26.036 0 0033.597 7.56z"
          />
        </>
      )}

      <g
        className="svg-icon-color-fill"
        fill="#fff"
        fillOpacity="1"
        stroke="none"
        strokeWidth="0.304"
        fontFamily="Nunito"
        fontSize="9.878"
        fontStretch="normal"
        fontStyle="normal"
        fontWeight="bold"
        transform="matrix(3.77953 0 0 3.77953 -563.981 -246.619)"
        style={{
          lineHeight: '1.25',
          fontVariantLigatures: 'normal',
          fontVariantCaps: 'normal',
          fontVariantNumeric: 'normal',
          fontVariantEastAsian: 'normal',
        }}
        fontVariant="normal"
        letterSpacing="0"
        wordSpacing="0"
      >
        <path
          d="M160.174 76.6q.592 0 .592.504 0 .523-.592.523h-3.754q-.257 0-.405-.148-.148-.158-.148-.385 0-.296.227-.533l2.252-2.42q.415-.455.603-.83.197-.385.197-.76 0-.465-.266-.712-.267-.247-.76-.247-.406 0-.791.158-.375.148-.76.415-.1.07-.198.119-.099.04-.198.04-.168 0-.296-.159-.119-.158-.119-.375 0-.149.05-.257.06-.109.178-.208.434-.345 1.017-.543.583-.207 1.166-.207 1.017 0 1.62.513.612.514.612 1.383 0 .603-.257 1.136-.257.524-.87 1.176l-1.708 1.817z"
          style={{
            fontVariantLigatures: 'normal',
            fontVariantCaps: 'normal',
            fontVariantNumeric: 'normal',
            fontVariantEastAsian: 'normal',
          }}
          strokeWidth="0.304"
          fontFamily="Nunito"
          fontSize="9.878"
          fontStretch="normal"
          fontStyle="normal"
          fontVariant="normal"
          fontWeight="bold"
        />
      </g>
    </$IndicatorImageSvg>
  );
};

export const KYCLevel3IndicatorImage: React.FunctionComponent<IIndicatorImageProps> = ({
  simplified = false,
  ...passProps
}) => {
  return (
    <$IndicatorImageSvg
      xmlns="http://www.w3.org/2000/svg"
      width="67"
      height="67"
      viewBox="0 0 67 67"
      version="1.1"
      {...(passProps as any)}
    >
      {!simplified && (
        <>
          <path
            className="svg-icon-color-fill"
            fill="#fff"
            strokeWidth="1.177"
            d="M33.463 0A33.598 33.598 0 000 33.598a33.598 33.598 0 0033.598 33.597 33.598 33.598 0 0033.597-33.597A33.598 33.598 0 0033.598 0a33.598 33.598 0 00-.135 0zm.135 2.732a30.866 30.866 0 0130.867 30.866 30.866 30.866 0 01-30.867 30.867A30.866 30.866 0 012.733 33.598 30.866 30.866 0 0133.598 2.732z"
          />
          <path
            className="svg-icon-color-fill"
            fill="#fff"
            stroke="none"
            strokeDasharray="none"
            strokeMiterlimit="4"
            strokeWidth="1.18"
            d="M33.598 7.56A26.036 26.036 0 007.56 33.599a26.036 26.036 0 0026.037 26.037 26.036 26.036 0 0026.037-26.037A26.036 26.036 0 0033.598 7.56zm-.074 2.731a23.307 23.307 0 01.074 0 23.307 23.307 0 0123.306 23.307 23.307 23.307 0 01-23.306 23.306A23.307 23.307 0 0110.29 33.598 23.307 23.307 0 0133.523 10.29z"
          />
        </>
      )}

      <g
        className="svg-icon-color-fill"
        fill="#fff"
        fillOpacity="1"
        stroke="none"
        strokeWidth="0.304"
        fontFamily="Nunito"
        fontSize="9.878"
        fontStretch="normal"
        fontStyle="normal"
        fontWeight="bold"
        transform="matrix(3.77953 0 0 3.77953 -683.981 -246.619)"
        style={{
          lineHeight: '1.25',
          fontVariantLigatures: 'normal',
          fontVariantCaps: 'normal',
          fontVariantNumeric: 'normal',
          fontVariantEastAsian: 'normal',
        }}
        fontVariant="normal"
        letterSpacing="0"
        wordSpacing="0"
      >
        <path
          d="M191.035 74.052q.622.158.948.602.336.435.336 1.087 0 .899-.662 1.432-.662.533-1.788.533-.642 0-1.235-.197-.592-.198-1.007-.553-.227-.198-.227-.465 0-.217.118-.365.129-.158.297-.158.098 0 .177.04.08.03.218.108.415.277.79.425.375.148.82.148.652 0 .968-.257.316-.266.316-.8 0-.523-.336-.77-.326-.257-1.017-.257h-.563q-.228 0-.356-.148-.118-.158-.118-.356 0-.207.118-.356.128-.148.356-.148h.395q1.353 0 1.353-1.017 0-.474-.286-.731-.287-.257-.79-.257-.722 0-1.542.573-.138.079-.217.119-.079.03-.178.03-.168 0-.296-.149-.119-.158-.119-.375 0-.149.05-.247.06-.109.178-.218.415-.345.987-.543.583-.207 1.186-.207 1.027 0 1.63.503.612.504.612 1.344-.01.573-.306 1.007-.287.425-.81.623z"
          style={{
            fontVariantLigatures: 'normal',
            fontVariantCaps: 'normal',
            fontVariantNumeric: 'normal',
            fontVariantEastAsian: 'normal',
          }}
          strokeWidth="0.304"
          fontFamily="Nunito"
          fontSize="9.878"
          fontStretch="normal"
          fontStyle="normal"
          fontVariant="normal"
          fontWeight="bold"
        />
      </g>
    </$IndicatorImageSvg>
  );
};

export const EmailVerificationIndicatorImage: React.FunctionComponent<IIndicatorImageProps> = ({
  simplified = false,
  ...passProps
}) => {
  return (
    <$IndicatorImageSvg
      xmlns="http://www.w3.org/2000/svg"
      width="67"
      height="67"
      viewBox="0 0 67 67"
      version="1.1"
      {...(passProps as any)}
    >
      <path
        className="svg-icon-color-fill"
        d="M6.02 13.054v39.938a.997 1.067 0 000 .17v.978h55.158V13.054H7.015zm4.39 2.132h46.377l-23.188 15.95zm-2.398.887l16.506 11.35L8.012 49.976zm51.175 0v33.966L42.41 27.61zM26.186 28.598l6.876 4.708a.997 1.067 0 001.075 0l6.598-4.52 17.37 23.221H9.059z"
        style={{
          lineHeight: 'normal',
          fontVariantLigatures: 'normal',
          fontVariantPosition: 'normal',
          fontVariantCaps: 'normal',
          fontVariantNumeric: 'normal',
          fontVariantAlternates: 'normal',
          fontVariantEastAsian: 'normal',
          fontFeatureSettings: 'normal',
          fontVariationSettings: 'normal',
          textIndent: '0',
          textAlign: 'start',
          WebkitTextDecorationLine: 'none',
          textDecorationLine: 'none',
          WebkitTextDecorationStyle: 'solid',
          textDecorationStyle: 'solid',
          WebkitTextDecorationColor: '#000000',
          textDecorationColor: '#000000',
          textTransform: 'none',
          WebkitTextOrientation: 'mixed',
          textOrientation: 'mixed',
          whiteSpace: 'normal',
          shapeMargin: '0',
          inlineSize: '0',
          isolation: 'auto',
          mixBlendMode: 'normal',
        }}
        fill="#fff"
        fillOpacity="1"
        fillRule="nonzero"
        stroke="none"
        strokeDasharray="none"
        strokeDashoffset="0"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="2.062"
        baselineShift="baseline"
        clipRule="nonzero"
        color="#000"
        colorInterpolation="sRGB"
        colorInterpolationFilters="linearRGB"
        colorRendering="auto"
        direction="ltr"
        display="inline"
        dominantBaseline="auto"
        enableBackground="accumulate"
        fontFamily="sans-serif"
        fontSize="medium"
        fontStretch="normal"
        fontStyle="normal"
        fontVariant="normal"
        fontWeight="normal"
        imageRendering="auto"
        letterSpacing="normal"
        opacity="1"
        overflow="visible"
        paintOrder="stroke fill markers"
        shapeRendering="auto"
        stopColor="#000"
        stopOpacity="1"
        textAnchor="start"
        textDecoration="none"
        textRendering="auto"
        vectorEffect="none"
        visibility="visible"
        wordSpacing="normal"
        writingMode="lr-tb"
      />
    </$IndicatorImageSvg>
  );
};

export const AccountAlertIndicatorImage: React.FunctionComponent<IIndicatorImageProps> = ({
  simplified = false,
  ...passProps
}) => {
  return (
    <$IndicatorImageSvg
      xmlns="http://www.w3.org/2000/svg"
      width="67"
      height="67"
      viewBox="0 0 67 67"
      version="1.1"
      {...(passProps as any)}
    >
      <g
        style={{
          lineHeight: '1.25',
          fontVariantLigatures: 'normal',
          fontVariantCaps: 'normal',
          fontVariantNumeric: 'normal',
          fontVariantEastAsian: 'normal',
        }}
        className="svg-icon-color-fill"
        fillOpacity="1"
        stroke="none"
        strokeWidth="0.304"
        fontFamily="Nunito"
        fontSize="9.878"
        fontStretch="normal"
        fontStyle="normal"
        fontVariant="normal"
        fontWeight="bold"
        letterSpacing="0"
        transform="matrix(3.77953 0 0 3.77953 -83.99 -664.62)"
        wordSpacing="0"
      >
        <path
          className="svg-icon-color-stroke"
          style={{
            fontVariantLigatures: 'normal',
            fontVariantCaps: 'normal',
            fontVariantNumeric: 'normal',
            fontVariantEastAsian: 'normal',
          }}
          strokeWidth="0.304"
          d="M31.111 186.728q-.148 0-.257-.1-.098-.098-.118-.286l-.366-3.842-.01-.099q0-.306.208-.484.217-.188.543-.188.346 0 .563.218.218.207.178.563l-.365 3.832q-.02.188-.129.287-.099.098-.247.098zm0 2.074q-.316 0-.523-.208-.208-.217-.208-.533 0-.316.208-.523.207-.218.523-.218.316 0 .524.218.207.207.207.523 0 .316-.207.533-.208.208-.524.208z"
          fontFamily="Nunito"
          fontSize="9.878"
          fontStretch="normal"
          fontStyle="normal"
          fontVariant="normal"
          fontWeight="bold"
        />
      </g>
      <path
        fill="none"
        className="svg-icon-color-stroke"
        strokeDasharray="none"
        strokeDashoffset="0"
        strokeLinecap="butt"
        strokeLinejoin="round"
        strokeMiterlimit="4"
        strokeWidth="2.6"
        d="M33.588 7.682l13.758 23.915 13.757 23.916H6.073l13.758-23.916z"
        paintOrder="normal"
      />
    </$IndicatorImageSvg>
  );
};

export const KYC_LEVEL_INDICATOR_IMAGES = {
  0: KYCLevel0IndicatorImage,
  1: KYCLevel1IndicatorImage,
  2: KYCLevel2IndicatorImage,
  3: KYCLevel3IndicatorImage,
};

export const ClockIcon = (props) => {
  return (
    <svg viewBox="0 0 640 640" {...props}>
      <path
        className="svg-icon-color-fill"
        d="M320 25.6C157.408 25.6 25.6 157.44 25.6 320c0 162.592 131.808 294.4 294.4 294.4S614.4 482.592 614.4 320c0-162.592-131.808-294.4-294.4-294.4zm0 524.8C192.736 550.4 89.6 447.232 89.6 320S192.736 89.6 320 89.6 550.4 192.768 550.4 320 447.264 550.4 320 550.4zm22.4-396.8h-44.8v175.68l108.96 108.96 31.68-31.68-95.84-95.84z"
      />
    </svg>
  );
};

// LOADING CIRCLE SVG

export interface ILoadingCircleInheritedProps {
  containerSize?: number;
  lineWidth?: string;
  colorCircleOne?: IThemeColorsUnion;
  tickSide?: 'left' | 'right';
  radius?: number;
}
interface ILoadingCircleProps extends ILoadingCircleInheritedProps {
  strokeDashOffset: number;
}
interface ILoadingCircleState {}
interface IStyledLoadingCircleProps extends ILoadingCircleInheritedProps {
  colorCircleOnTwoQuaters: boolean;
  colorCircleOnThreeQuaters: boolean;
}

const $LoadingCircleSvg = styled.svg<IStyledLoadingCircleProps>`
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: ${(p) => p.containerSize}px;
  height: ${(p) => p.containerSize}px;

  circle:first-child {
    fill: none;
    stroke: ${(p) => (p.colorCircleOne ? p.theme.colors[p.colorCircleOne] : '#2c5b8d')};
    stroke-width: ${(p) => (p.lineWidth ? p.lineWidth : '5')};
  }
  circle:last-child {
    transform: rotate(-90deg) ${(p) => (p.tickSide === 'left' ? '' : 'scaleY(-1)')};
    transform-origin: center;

    fill: none;
    stroke: ${(p) =>
      p.colorCircleOnTwoQuaters
        ? p.theme.colors.warning
        : p.colorCircleOnThreeQuaters
        ? p.theme.colors.error
        : p.theme.colors.info};
    stroke-width: ${(p) => (p.lineWidth ? p.lineWidth : '5')};
    transition: stroke 0.5s linear;
  }
`;

export class LoadingCircle extends React.PureComponent<ILoadingCircleProps, ILoadingCircleState> {
  static defaultProps: ILoadingCircleProps = {
    tickSide: 'left',
    containerSize: 250,
    radius: 100,
    strokeDashOffset: 0,
  };

  render() {
    const { containerSize, radius, tickSide } = this.props;

    const c = {
      x: containerSize / 2,
      y: containerSize / 2,
    };

    const strokeDashArray = 2 * Math.PI * radius;
    const { strokeDashOffset } = this.props;
    const colorCircleOn = {
      ['50%']:
        strokeDashOffset >= strokeDashArray * 0.5 && strokeDashOffset < strokeDashArray * 0.75,
      ['75%']: strokeDashOffset >= strokeDashArray * 0.75,
    };

    return (
      <$LoadingCircleSvg
        containerSize={containerSize}
        tickSide={tickSide}
        colorCircleOnTwoQuaters={colorCircleOn['50%']}
        colorCircleOnThreeQuaters={colorCircleOn['75%']}
      >
        {/* Circle in background */}
        <circle
          cx={c.x}
          cy={c.y}
          r={radius}
          strokeDasharray={`${strokeDashArray}`}
          strokeDashoffset={`0`}
        />
        {/* Timing circle */}
        <circle
          cx={c.x}
          cy={c.y}
          r={radius}
          strokeDasharray={`${strokeDashArray}`}
          strokeDashoffset={`${strokeDashOffset}`}
        />
      </$LoadingCircleSvg>
    );
  }
}
